// Copyright (c) 2026 杨翔宇（武汉文理学院）
// 物理智能教学智能体平台 (Physics Intelligent Agent)
// 保留所有权利 (All Rights Reserved)。未经著作权人书面许可，
// 不得以任何形式复制、传播、修改或用于商业用途。

export const zh: Record<string, string> = {
  'sidebar.brand': '万象',
  'sidebar.primaryNavigation': '常用入口',
  'sidebar.recent': '最近',
  'settings.archived.title': '已归档的聊天',
  'settings.archived.description': '归档的聊天不会出现在最近列表中。你可以查看或恢复它们。',
  'settings.archived.search': '搜索已归档的聊天',
  'settings.archived.empty': '暂无已归档的聊天',
  'settings.archived.failed': '无法完成归档操作，请重试。',
  'settings.archived.restore': '恢复',
  'settings.archived.restoreNamed': '恢复聊天：{title}',
  'settings.archived.restoring': '正在恢复…',
  'settings.archived.loadMore': '加载更多',
  'sidebar.learningSpace': '学习空间',
  'nav.sidebar': '导航栏',
  'nav.workspaces': '课程与项目',
  'nav.pinned': '置顶',
  'nav.loadFailed': '导航加载失败，可重试',
  'nav.untitled': '未命名会话',
  'nav.noWorkspaces': '暂无课程/项目',
  'nav.unpin': '取消置顶',
  'nav.searchTitles': '搜索会话标题',
  'nav.searching': '搜索中…',
  'nav.searchFailed': '搜索失败，请重试',
  'nav.noResults': '没有找到匹配的会话',
  'nav.pin': '置顶',
  'settings.archived.section': '已归档',
  'nav.loadMore': '加载更多',
  'sidebar.sessionActions': '聊天操作：{title}',
  'app.name': '万象 (OmniPhysics)AI',
  'app.maintenance.networkFallbackMessage': '服务正在重新启动，请稍候...',
  'app.a11y.skipToContent': '跳到主要内容',
  'user.fallbackName': '用户',

  'common.save': '保存',
  'common.reset': '重置',
  'common.back': '返回',
  'common.refresh': '刷新',
  'common.loading': '加载中...',
  'common.backToChat': '返回聊天',
  'common.cancel': '取消',
  'common.error': '操作失败，请重试',
  'common.delete': '删除',
  'common.language': '语言',
  'common.pause': '暂停',
  'common.resume': '继续',
  'common.enabled': '启用',
  'common.disabled': '停用',
  'common.available': '可用',
  'common.unavailable': '不可用',
  'common.none': '无',
  'common.on': '开',
  'common.off': '关',
  'common.yes': '是',
  'common.no': '否',
  'common.doc': '文档',
  'common.prev': '上一页',
  'common.next': '下一页',
  'language.en': 'English',
  'language.zh': '中文',

  'sidebar.newChat': '新建对话',
  'sidebar.noConversations': '暂无对话',
  'sidebar.newConversation': '新对话',
  'sidebar.search': '搜索对话',
  'sidebar.noResults': '没有匹配结果',
  'sidebar.toggle.open': '展开侧边栏',
  'sidebar.toggle.close': '收起侧边栏',
  'sidebar.rename': '重命名',
  'sidebar.archive': '归档',
  'sidebar.unarchive': '取消归档',
  'sidebar.delete': '删除',
  'sidebar.deleteConfirm': '确定删除该对话？此操作不可撤销。',
  'sidebar.share': '分享',
  'sidebar.shareCopied': '对话已复制到剪贴板',
  'sidebar.showArchived': '显示归档',
  'sidebar.hideArchived': '隐藏归档',
  'sidebar.archivedSection': '已归档',
  'sidebar.renamePlaceholder': '输入新名称...',
  'sidebar.group.today': '今天',
  'sidebar.group.yesterday': '昨天',
  'sidebar.group.previous7Days': '最近 7 天',
  'sidebar.group.previous30Days': '最近 30 天',
  'sidebar.group.older': '更早',

  'header.settings': '设置',
  'auth.logout': '退出登录',

  'userMenu.open': '打开菜单',
  'userMenu.settings': '设置',
  'userMenu.workflowEditor': '工作流编辑器',
  'userMenu.theme': '主题',
  'userMenu.theme.light': '浅色',
  'userMenu.theme.dark': '深色',
  'userMenu.theme.system': '跟随系统',
  'userMenu.adminPanel': '管理后台',
  'userMenu.mastery': '学习掌握度',
  // B4 mastery dashboard（Phase 2 rollout 批次二）
  'mastery.eyebrow': '学习画像',
  'mastery.title': '学习掌握度',
  'mastery.subtitle': '基于知识追踪后验与错题复习记录，呈现你当前各物理主题的掌握情况。',
  'mastery.loading': '正在加载掌握度数据…',
  'mastery.loadFailed': '掌握度数据加载失败，请稍后重试。',
  'mastery.ktSectionTitle': '主题掌握度（BKT 后验）',
  'mastery.ktEmpty': '暂无掌握度数据——完成练习或错题复习后，这里会逐步生成你的学习画像。',
  'mastery.observations': '{count} 次观察',
  'mastery.level.beginner': '入门',
  'mastery.level.intermediate': '进阶',
  'mastery.level.advanced': '熟练',
  'mastery.errorStatsTitle': '错题统计',
  'mastery.errorCountLabel': '累计错题',
  'mastery.mostCommonTopicLabel': '最薄弱主题',
  'mastery.reviewAccuracyLabel': '复习正确率',
  'mastery.mistakeBookTitle': '错题复习记录',
  'mastery.mistakeBookEmpty': '还没有错题复习记录。',
  'mastery.untitledTopic': '未分类主题',
  'mastery.roundCorrect': '答对',
  'mastery.roundIncorrect': '答错',
  'mastery.yourAnswer': '你的答案',
  'mastery.referenceAnswer': '参考答案',
  'mastery.explanation': '解析',
  // C5 Co-Writer diff（Phase 2 rollout 批次三）
  'cowriter.title': '变更审批（Co-Writer）',
  'cowriter.noPendingChanges': '没有待审批的变更——所有修改需经你确认才会落地。',
  'cowriter.pendingCount': '{count} 项待审批',
  'cowriter.accept': '采纳',
  'cowriter.reject': '拒绝',
  'cowriter.before': '变更前',
  'cowriter.after': '变更后',
  'cowriter.kind.regenerate': '重新生成',
  'cowriter.kind.insert': '插入块',
  'cowriter.kind.move': '移动块',
  'cowriter.kind.retype': '更换类型',
  'userMenu.logout': '退出登录',

  'admin.sidebar.title': '管理后台',
  'admin.sidebar.dashboard': '仪表盘',
  'admin.sidebar.users': '用户管理',
  'admin.sidebar.usage': '用量分析',
  'admin.sidebar.sessions': '会话管理',
  'admin.sidebar.system': '系统状态',
  'admin.sidebar.subscriptions': '订阅管理',
  'admin.sidebar.orders': '订单管理',
  'admin.sidebar.plans': '套餐管理',
  'admin.sidebar.settings': '后台设置',
  'admin.sidebar.backToApp': '返回应用',
  'admin.sidebar.enterChat': '进入聊天',
  'admin.sidebar.logout': '退出登录',
  'admin.sidebar.language': '语言切换',
  'admin.sidebar.expand': '展开',
  'admin.sidebar.collapse': '收起',
  'admin.sidebar.version': 'v{version}',

  'admin.dashboard.title': '仪表盘',
  'admin.dashboard.subtitle': '系统概览与核心指标',
  'admin.dashboard.kpi.totalUsers': '用户总数',
  'admin.dashboard.kpi.totalUsers.desc': '已注册账号',
  'admin.dashboard.kpi.activeUsersToday': '今日活跃用户',
  'admin.dashboard.kpi.activeUsersToday.desc': '今日有请求的用户',
  'admin.dashboard.kpi.requestsToday': '今日请求数',
  'admin.dashboard.kpi.tokensToday': '今日 Token 数',
  'admin.dashboard.kpi.totalSessions': '会话总数',
  'admin.dashboard.kpi.errorsToday': '今日错误数',
  'admin.dashboard.kpi.activeUsersTotal': '启用用户总数',
  'admin.dashboard.kpi.activeUsersTotal.desc': '当前启用账号',
  'admin.dashboard.kpi.onlineUsersRealtime': '实时在线用户',
  'admin.dashboard.kpi.totalTokensAllTime': '累计 Token 总量',
  'admin.dashboard.kpi.totalTokensAllTime.desc': '所有时间累计消耗',
  'admin.dashboard.kpi.rpm': 'RPM（请求/分钟）',
  'admin.dashboard.kpi.rpm.desc': '近 5 分钟平均',
  'admin.dashboard.kpi.tpm': 'TPM（Token/分钟）',
  'admin.dashboard.kpi.tpm.desc': '近 5 分钟平均',
  'admin.dashboard.kpi.activeSubscriptions': '活跃订阅',
  'admin.dashboard.kpi.totalRevenue': '累计营收',
  'admin.dashboard.kpi.totalOrders': '订单总数',
  'admin.dashboard.kpi.paidOrders': '已支付订单',
  'admin.dashboard.requestTrend7Days': '近 7 天请求趋势',
  'admin.dashboard.serviceHealth': '服务健康状态',
  'admin.dashboard.topUsers7Days': '近 7 天高活跃用户',
  'admin.dashboard.req': '次请求',
  'admin.dashboard.tok': 'Token',
  'admin.dashboard.noUsageData': '暂无用量数据',
  'admin.dashboard.tokens.localSource': '本地统计',
  'admin.common.noData': '暂无可用数据',
  'admin.common.prev': '上一页',
  'admin.common.next': '下一页',
  'admin.common.pageOf': '第 {page} / {total} 页',
  'admin.health.healthy': '正常',
  'admin.health.degraded': '降级',
  'admin.health.unhealthy': '异常',
  'admin.health.unknown': '未知',

  'admin.users.title': '用户管理',
  'admin.users.subtitle': '共 {total} 个用户',
  'admin.users.addUser': '新增用户',
  'admin.users.search.placeholder': '按邮箱或姓名搜索...',
  'admin.users.table.email': '邮箱',
  'admin.users.table.name': '姓名',
  'admin.users.table.role': '角色',
  'admin.users.table.status': '状态',
  'admin.users.table.rateLimit': '限流',
  'admin.users.table.lastLogin': '最后登录',
  'admin.users.table.researchPlan': '科研套餐',
  'admin.users.table.actions': '操作',
  'admin.users.role.user': 'user',
  'admin.users.role.admin': 'admin',
  'admin.users.status.active': '启用',
  'admin.users.status.disabled': '停用',
  'admin.users.default': '默认',
  'admin.users.action.disable': '停用',
  'admin.users.action.enable': '启用',
  'admin.users.action.resetPassword': '重置密码',
  'admin.users.action.delete': '删除用户',
  'admin.users.deleteProtect.self': '不能删除当前登录账号',
  'admin.users.deleteProtect.lastAdmin': '不能删除最后一个激活管理员',
  'admin.users.roleProtect.lastAdmin': '最后一个激活管理员不能降权',
  'admin.users.empty': '暂无用户',
  'admin.users.toast.userCreated': '用户创建成功',
  'admin.users.toast.createFailed': '创建用户失败',
  'admin.users.toast.userDisabled': '用户已停用',
  'admin.users.toast.userEnabled': '用户已启用',
  'admin.users.toast.operationFailed': '操作失败',
  'admin.users.toast.passwordReset': '密码重置成功',
  'admin.users.toast.passwordResetFailed': '密码重置失败',
  'admin.users.toast.roleUpdated': '角色更新成功',
  'admin.users.toast.roleUpdateFailed': '角色更新失败',
  'admin.users.toast.researchPlanUpdated': '科研套餐已更新',
  'admin.users.toast.researchPlanUpdateFailed': '更新科研套餐失败',
  'admin.users.toast.userDeleted': '用户删除成功',
  'admin.users.toast.userDeleteFailed': '删除用户失败',
  'admin.users.researchPlan.ariaLabel': '调整 {email} 的科研套餐',
  'admin.users.researchPlan.placeholder': '调整套餐',
  'admin.users.researchPlan.free': '免费版',
  'admin.users.researchPlan.pro': '专业版·开启科研',
  'admin.users.researchPlan.max': '旗舰版·完整科研',
  'admin.users.action.features': '功能权限',
  'admin.users.features.title': '功能权限管理',
  'admin.users.features.description': '为 {email} 单独开启或关闭高级功能（优先于套餐）',
  'admin.users.features.plan': '当前套餐',
  'admin.users.features.planDefault': '套餐默认',
  'admin.users.features.unset': '未声明',
  'admin.users.features.overridden.allow': '已单独允许',
  'admin.users.features.overridden.deny': '已单独禁止',
  'admin.users.features.effective.on': '已开启',
  'admin.users.features.effective.off': '已关闭',
  'admin.users.features.allow': '允许',
  'admin.users.features.deny': '禁止',
  'admin.users.features.inherit': '继承套餐',
  'admin.users.features.adminBypassHint': '（管理员角色默认绕过功能门控）',
  'admin.users.features.loadFailed': '加载功能权限失败',
  'admin.users.features.updated': '功能权限已更新',
  'admin.users.features.updateFailed': '更新功能权限失败',
  'admin.users.features.featureLabel.deep_thinking': '深度思考',
  'admin.users.features.featureLabel.research_workbench': '高级科研工作台',
  'admin.users.features.featureLabel.priority_response': '优先响应',
  'admin.users.dialog.create.title': '创建用户',
  'admin.users.dialog.create.email': '邮箱',
  'admin.users.dialog.create.name': '姓名',
  'admin.users.dialog.create.password': '密码（至少 8 位）',
  'admin.users.dialog.create.submit': '创建',
  'admin.users.dialog.resetPassword.title': '重置密码',
  'admin.users.dialog.resetPassword.newPasswordPlaceholder': '新密码（至少 8 位）',
  'admin.users.dialog.resetPassword.submit': '重置',
  'admin.users.action.accessLink': '评委直达链接',
  'admin.users.dialog.accessLink.title': '生成评委直达链接',
  'admin.users.dialog.accessLink.description':
    '为 {email} 签发一条免账号密码的直达登录链接，评委打开即进入系统',
  'admin.users.dialog.accessLink.ttl': '有效期',
  'admin.users.dialog.accessLink.ttl.1d': '1 天',
  'admin.users.dialog.accessLink.ttl.7d': '7 天（推荐）',
  'admin.users.dialog.accessLink.ttl.30d': '30 天',
  'admin.users.dialog.accessLink.ttl.90d': '90 天',
  'admin.users.dialog.accessLink.ttl.180d': '180 天（半年）',
  'admin.users.dialog.accessLink.ttl.365d': '365 天（一年）',
  'admin.users.dialog.accessLink.generatedUrl': '直达链接（复制后发给评委，或做成二维码）',
  'admin.users.dialog.accessLink.copy': '复制',
  'admin.users.dialog.accessLink.hint': '链接内不含账号与密码；到期自动失效，也可在此随时吊销。',
  'admin.users.dialog.accessLink.generate': '生成链接',
  'admin.users.dialog.accessLink.revoke': '吊销链接',
  'admin.users.toast.accessLinkCreated': '链接已生成',
  'admin.users.toast.accessLinkCreateFailed': '生成链接失败',
  'admin.users.toast.accessLinkCopied': '链接已复制到剪贴板',
  'admin.users.toast.accessLinkCopyFailed': '复制失败，请手动选择复制',
  'admin.users.toast.accessLinkRevoked': '链接已吊销',
  'admin.users.toast.accessLinkRevokeFailed': '吊销失败（链接可能已过期）',
  'admin.users.dialog.delete.title': '确认删除用户',
  'admin.users.dialog.delete.description': '即将删除用户：{email}',
  'admin.users.dialog.delete.warning': '该操作不可撤销，请谨慎操作。',
  'admin.users.dialog.delete.submit': '确认删除',
  'admin.users.batch.toolbar.countSelected': '已选 {count} 项',
  'admin.users.batch.toolbar.clearSelection': '取消选择',
  'admin.users.batch.toolbar.selectAll': '全选',
  'admin.users.batch.toolbar.bulkCreate': '批量添加',
  'admin.users.batch.action.enable': '批量启用',
  'admin.users.batch.action.disable': '批量停用',
  'admin.users.batch.action.setRole': '批量设置角色',
  'admin.users.batch.action.delete': '批量删除',
  'admin.users.batch.action.resetPassword': '批量重置密码',
  'admin.users.batch.protect.selfInBatch': '批量操作不能包含当前登录账号',
  'admin.users.batch.protect.lastAdminInBatch': '批量操作会影响最后一个激活管理员',
  'admin.users.batch.toast.batchUpdated': '批量更新成功（共 {count} 项）',
  'admin.users.batch.toast.batchUpdateFailed': '批量更新失败',
  'admin.users.batch.toast.batchDeleted': '批量删除成功（共 {count} 项）',
  'admin.users.batch.toast.batchDeleteFailed': '批量删除失败',
  'admin.users.batch.toast.batchPasswordReset': '批量重置密码成功（共 {count} 项）',
  'admin.users.batch.toast.batchPasswordResetFailed': '批量重置密码失败',
  'admin.users.batch.toast.batchCreated': '批量创建成功（共 {count} 个用户）',
  'admin.users.batch.toast.batchCreateFailed': '批量创建失败',
  'admin.users.batch.dialog.batchDelete.title': '确认批量删除',
  'admin.users.batch.dialog.batchDelete.description': '即将永久删除选中的 {count} 个用户。',
  'admin.users.batch.dialog.batchDelete.warning': '该操作不可撤销，将级联删除用户的会话、用量记录等数据，请谨慎操作。',
  'admin.users.batch.dialog.batchDelete.submit': '确认删除',
  'admin.users.batch.dialog.batchResetPassword.title': '批量重置密码',
  'admin.users.batch.dialog.batchResetPassword.description': '将为选中的 {count} 个用户设置同一个临时密码。',
  'admin.users.batch.dialog.batchResetPassword.newPasswordPlaceholder': '新密码（至少 8 位）',
  'admin.users.batch.dialog.batchResetPassword.submit': '重置',
  'admin.users.batch.dialog.batchUpdate.title': '批量设置角色',
  'admin.users.batch.dialog.batchUpdate.description': '将选中的 {count} 个用户角色统一设置为：',
  'admin.users.batch.dialog.bulkCreate.title': '批量添加用户',
  'admin.users.batch.dialog.bulkCreate.hint': '每行一个用户，格式：邮箱,姓名,密码（密码至少 8 位）',
  'admin.users.batch.dialog.bulkCreate.placeholder': 'alice@example.com,Alice,12345678\nbob@example.com,Bob,87654321',
  'admin.users.batch.dialog.bulkCreate.submit': '批量创建',
  'admin.users.batch.dialog.bulkCreate.parseError': '第 {line} 行格式错误，应为：邮箱,姓名,密码',

  'admin.usage.title': '用量分析',
  'admin.usage.subtitle': '资源消耗趋势',
  'admin.usage.range.today': '今天',
  'admin.usage.range.7days': '7 天',
  'admin.usage.range.30days': '30 天',
  'admin.usage.requestTrend': '请求趋势',
  'admin.usage.tokenConsumption': 'Token 消耗',
  'admin.usage.userLeaderboard': '用户排行榜',
  'admin.usage.modelDistribution': '模型分布',
  'admin.usage.eventTypeBreakdown': '事件类型分布',
  'admin.usage.req': '次请求',
  'admin.usage.tok': 'Token',
  'admin.usage.tokens': 'Token',
  'admin.usage.refresh': '刷新',
  'admin.usage.summary': '总览',
  'admin.usage.summaryRequests': '请求数',
  'admin.usage.summaryTotalTokens': '总 Token',
  'admin.usage.summaryInputTokens': '输入 Token',
  'admin.usage.summaryOutputTokens': '输出 Token',
  'admin.usage.summaryCacheRead': '缓存读取',
  'admin.usage.summaryCacheCreation': '缓存创建',
  'admin.usage.summaryCost': '成本',
  'admin.usage.providerBreakdown': '按 Provider 维度',
  'admin.usage.sessionBreakdown': '按会话维度',
  'admin.usage.modelBreakdown': '按模型维度',
  'admin.usage.colProvider': 'Provider',
  'admin.usage.colRequests': '请求数',
  'admin.usage.colTotalTokens': '总 Token',
  'admin.usage.colCacheRead': '缓存读取',
  'admin.usage.colCacheCreation': '缓存创建',
  'admin.usage.colCost': '成本',
  'admin.usage.colCostStatus': '成本状态',
  'admin.usage.colThreadId': 'Thread ID',
  'admin.usage.colRuns': '运行数',
  'admin.usage.colLastSeen': '最后活跃',
  'admin.usage.colModel': '模型',
  'admin.usage.empty': '所选范围暂无用量数据。',
  'admin.usage.error': '加载用量维度数据失败。',
  'admin.usage.unknown': '未知',
  'admin.usage.loading': '正在加载用量数据…',
  'admin.usage.csv': 'CSV',
  'admin.usage.exportCsv': '导出 CSV',

  'admin.subscriptions.title': '订阅与订单管理',
  'admin.subscriptions.subtitle': '管理用户订阅和支付订单',
  'admin.subscriptions.tab.subscriptions': '订阅',
  'admin.subscriptions.tab.orders': '订单',
  'admin.subscriptions.filter.all': '全部',
  'admin.subscriptions.filter.active': '活跃',
  'admin.subscriptions.filter.expired': '已过期',
  'admin.subscriptions.filter.cancelled': '已取消',
  'admin.subscriptions.filter.paid': '已支付',
  'admin.subscriptions.filter.pending': '待支付',
  'admin.subscriptions.filter.failed': '失败',
  'admin.subscriptions.filter.refunded': '已退款',
  'admin.subscriptions.search.subscriptions': '搜索用户 ID 或套餐',
  'admin.subscriptions.search.orders': '搜索订单号、用户 ID 或套餐',
  'admin.subscriptions.col.userId': '用户 ID',
  'admin.subscriptions.col.plan': '套餐',
  'admin.subscriptions.col.status': '状态',
  'admin.subscriptions.col.periodStart': '开始日期',
  'admin.subscriptions.col.periodEnd': '到期日期',
  'admin.subscriptions.col.autoRenew': '自动续费',
  'admin.subscriptions.col.orderNo': '订单号',
  'admin.subscriptions.col.amount': '金额',
  'admin.subscriptions.col.cycle': '周期',
  'admin.subscriptions.col.paymentStatus': '支付状态',
  'admin.subscriptions.col.paidAt': '支付时间',
  'admin.subscriptions.col.actions': '操作',
  'admin.subscriptions.action.downgrade': '降级为免费版',
  'admin.subscriptions.action.cancelOrder': '取消订单',
  'admin.subscriptions.action.refundOrder': '退款',
  'admin.subscriptions.confirm.downgrade': '确定将该用户订阅降级为免费版吗？',
  'admin.subscriptions.confirm.cancelOrder': '确定取消该待支付订单吗？',
  'admin.subscriptions.confirm.refund': '确定退款该订单并回退对应订阅吗？',
  'admin.subscriptions.toast.subscriptionDowngraded': '订阅已降级为免费版',
  'admin.subscriptions.toast.subscriptionDowngradeFailed': '降级订阅失败',
  'admin.subscriptions.toast.orderCancelled': '待支付订单已取消',
  'admin.subscriptions.toast.orderCancelFailed': '取消订单失败',
  'admin.subscriptions.toast.orderRefunded': '已退款并回退订阅',
  'admin.subscriptions.toast.orderRefundFailed': '退款失败',

  'admin.plans.title': '套餐管理',
  'admin.plans.subtitle': '编辑现有套餐的价格、配额和上下架状态',
  'admin.plans.col.code': '代码',
  'admin.plans.col.name': '套餐',
  'admin.plans.col.actions': '操作',
  'admin.plans.field.description': '描述',
  'admin.plans.field.priceMonthly': '月付价格',
  'admin.plans.field.priceYearly': '年付价格',
  'admin.plans.field.dailyMessages': '每日消息数',
  'admin.plans.field.contextLength': '上下文长度',
  'admin.plans.field.knowledgeBases': '知识库数量',
  'admin.plans.field.fileSize': '文件大小（MB）',
  'admin.plans.field.sortOrder': '排序',
  'admin.plans.field.isActive': '启用',
  'admin.plans.action.create': '新建套餐',
  'admin.plans.action.save': '保存',
  'admin.plans.dialog.create.title': '新建套餐',
  'admin.plans.dialog.create.description': '创建一个新的会员套餐，并配置基础价格与配额。',
  'admin.plans.dialog.create.code': '套餐代码',
  'admin.plans.dialog.create.name': '套餐名称',
  'admin.plans.dialog.create.descriptionLabel': '套餐描述',
  'admin.plans.dialog.create.priceMonthly': '月付价格',
  'admin.plans.dialog.create.priceYearly': '年付价格',
  'admin.plans.dialog.create.dailyMessages': '每日消息数',
  'admin.plans.dialog.create.contextLength': '上下文长度',
  'admin.plans.dialog.create.knowledgeBases': '知识库数量',
  'admin.plans.dialog.create.fileSize': '文件大小（MB）',
  'admin.plans.dialog.create.sortOrder': '排序',
  'admin.plans.dialog.create.isActive': '创建后立即启用',
  'admin.plans.dialog.create.isActiveHint': '关闭后该套餐会保留在后台，但不会展示给用户。',
  'admin.plans.dialog.create.submit': '创建套餐',
  'admin.plans.toast.created': '套餐已创建',
  'admin.plans.toast.createFailed': '创建套餐失败',
  'admin.plans.toast.updated': '套餐已更新',
  'admin.plans.toast.updateFailed': '更新套餐失败',

  'admin.sessions.title': '会话管理',
  'admin.sessions.subtitle': '共 {total} 个会话',
  'admin.sessions.filter.placeholder': '按用户 ID 过滤...',
  'admin.sessions.empty': '暂无会话',
  'admin.sessions.untitled': '未命名会话',
  'admin.sessions.user': '用户',
  'admin.sessions.unknown': '未知',
  'admin.sessions.total': '个会话',
  'admin.sessions.msgs': '条消息',
  'admin.sessions.action.delete': '删除会话',
  'admin.sessions.loadingMessages': '正在加载消息...',
  'admin.sessions.noMessages': '暂无消息',
  'admin.sessions.expandMessage': '展开完整内容',
  'admin.sessions.collapseMessage': '收起内容',
  'admin.sessions.confirm.deleteSession': '确定删除该会话？',
  'admin.sessions.toast.deleted': '会话已删除',
  'admin.sessions.toast.deleteFailed': '删除会话失败',

  'admin.system.title': '系统健康',
  'admin.system.subtitle': '服务状态与基础设施指标',
  'admin.system.services': '服务状态',
  'admin.system.databasePool': '数据库连接池',
  'admin.system.rateLimits': '限流配置',
  'admin.system.metricsSummary': 'Prometheus 指标汇总',
  'admin.system.httpMetrics': 'HTTP 指标',
  'admin.system.chatMetrics': '对话指标',
  'admin.system.totalRequests': '总请求数',
  'admin.system.avgLatency': '平均延迟',
  'admin.system.statusDistribution': '状态分布',
  'admin.system.chatRequests': '对话请求数',
  'admin.system.totalTokens': 'Token 总量',
  'admin.system.exceededTotal': '超限总次数',
  'admin.system.totalPublishes': '发布总数',
  'admin.system.agentflowPublish': 'AgentFlow 发布',
  'admin.system.poolUtilization': '连接池使用率',
  'admin.system.poolSize': '连接池大小',
  'admin.system.checkedIn': '空闲连接',
  'admin.system.checkedOut': '占用连接',
  'admin.system.rateLimit.section.global': '全局',
  'admin.system.rateLimit.key.requests_per_minute': '每分钟请求数',
  'admin.system.rateLimit.key.window_seconds': '时间窗口（秒）',
  'admin.system.dbField.status': '状态',
  'admin.system.dbField.service': '服务',
  'admin.system.autoRefresh30s': '自动 30 秒',
  'admin.system.byModel': '按模型',
  'admin.system.websocket': 'WebSocket',
  'admin.system.activeConnections': '活跃连接数',
  'admin.system.frequencyPanel.title': '请求频率监控日志面板',
  'admin.system.frequencyPanel.all': '全部',
  'admin.system.frequencyPanel.threshold': '≥{threshold} rpm',
  'admin.system.frequencyPanel.exportCsv': '导出 CSV',
  'admin.system.frequencyPanel.rpm': '{rpm} req/min',
  'admin.system.frequencyPanel.csv.path': '路径',
  'admin.system.frequencyPanel.csv.deltaRequests': '增量请求',
  'admin.system.frequencyPanel.csv.requestsPerMin': '每分钟请求',
  'admin.system.frequencyPanel.csv.totalRequests': '总请求',
  'admin.system.frequencyPanel.empty': '暂无突增请求，等待下一轮采样',

  'admin.settings.title': '后台设置',
  'admin.settings.subtitle': '全局配置与审计日志',
  'admin.settings.maintenance.title': '维护模式',
  'admin.settings.maintenance.description':
    '开启后，普通用户将看到维护提示页面，无法使用系统。管理员仍可正常访问后台。',
  'admin.settings.maintenance.active': '维护模式开关',
  'admin.settings.maintenance.status.enabled': '当前已开启维护模式',
  'admin.settings.maintenance.status.disabled': '当前系统正常运行',
  'admin.settings.maintenance.message': '维护提示消息',
  'admin.settings.maintenance.messagePlaceholder': '请输入维护期间用户看到的提示消息…',
  'admin.settings.maintenance.save': '保存维护设置',
  'admin.settings.maintenance.warning':
    '开启维护模式后，普通用户将无法访问系统。请确保您能够登录管理员账号以关闭维护模式。',
  'admin.settings.toast.maintenanceUpdated': '维护设置已更新',
  'admin.settings.toast.maintenanceUpdateFailed': '更新维护设置失败',
  'admin.settings.commerce.title': '商业化功能开关',
  'admin.settings.commerce.description':
    '关闭后，普通用户将看不到套餐、支付、额度升级等商业化能力，相关前台接口也会被禁用。两开关相互独立：本开关只控制商业展示与交易；套餐配额限制由「配额限制开关」独立控制；身份、权限、沙箱等技术运行限制不受任何开关影响。',

  'admin.settings.commerce.enabled': '运行时开关',
  'admin.settings.commerce.status.enabled': '当前已开放普通用户商业化能力',
  'admin.settings.commerce.status.disabled': '当前已屏蔽普通用户商业化能力',
  'admin.settings.commerce.source': '当前来源：{source}',
  'admin.settings.commerce.save': '保存商业化开关',
  'admin.settings.solverMode.title': '解题器模式',
  'admin.settings.solverMode.description':
    '选择主聊天的解题策略。修改后经一次自动图重载生效，无需重启。',
  'admin.settings.solverMode.label': '当前模式',
  'admin.settings.solverMode.source': '当前来源：{source}',
  'admin.settings.solverMode.save': '保存解题器模式',
  'admin.settings.solverMode.option.legacy': 'Legacy（单候选，最省）',
  'admin.settings.solverMode.option.b3': 'B3（多采样验证选择）',
  'admin.settings.solverMode.option.b3_cascade':
    'B3 Cascade（难度自适应：廉价探针，难题才升级）',
  'admin.settings.quota.title': '配额限制开关',
  'admin.settings.quota.description':
    '无需重启网关，即可启用或暂停基于套餐的配额限制。关闭时已认证用户可正常使用已发布能力（不查询套餐）；开启而商业展示关闭时，限制提示为非商业措辞、不含升级诱导。',

  'admin.settings.quota.enabled': '运行时开关',
  'admin.settings.quota.status.enabled': '当前已启用限制',
  'admin.settings.quota.status.disabled': '当前已暂停限制',
  'admin.settings.quota.source': '当前来源：{source}',
  'admin.settings.quota.source.config_default': '配置默认值',
  'admin.settings.quota.source.runtime_override': '运行时覆盖值',
  'admin.settings.quota.save': '保存配额开关',
  'admin.settings.memory.title': '记忆存储限制',
  'admin.settings.memory.description':
    '控制每个用户最多保留多少条显式记忆。超过上限后，将自动删除最旧的记忆。',
  'admin.settings.memory.limit': '显式记忆上限',
  'admin.settings.memory.save': '保存记忆上限',
  'admin.settings.memory.source': '当前来源：{source}',
  'admin.settings.auth.title': '认证方式开关',
  'admin.settings.auth.description':
    '按认证方式控制注册、登录、验证和第三方认证入口。当前默认保留邮箱密码登录，公开注册和第三方认证默认关闭。',
  'admin.settings.auth.source': '当前来源：{source}',
  'admin.settings.auth.note':
    '仅开启开关但尚未注入真实 SMTP、QQ、微信或短信配置时，对应能力仍可能不可用。',
  'admin.settings.auth.adminEnabled': '管理员已开启',
  'admin.settings.auth.configured': '外部已配置',
  'admin.settings.auth.available': '最终可用',
  'admin.settings.auth.save': '保存认证方式开关',
  'admin.settings.auth.methods.emailPassword.title': '邮箱密码登录',
  'admin.settings.auth.methods.emailPassword.description':
    '控制邮箱密码登录入口，方便管理员和已分配账号的测试用户直接登录。',
  'admin.settings.auth.methods.emailRegistration.title': '邮箱注册',
  'admin.settings.auth.methods.emailRegistration.description':
    '控制公开邮箱注册入口，不影响管理员创建账号后的正常登录。',
  'admin.settings.auth.methods.emailVerification.title': '邮箱验证',
  'admin.settings.auth.methods.emailVerification.description':
    '控制邮箱验证码验证能力，以及登录前是否强制完成邮箱验证。',
  'admin.settings.auth.methods.qq.title': 'QQ 登录',
  'admin.settings.auth.methods.qq.description': '控制 QQ OAuth 登录入口。',
  'admin.settings.auth.methods.wechat.title': '微信登录',
  'admin.settings.auth.methods.wechat.description': '控制微信 OAuth 登录入口。',
  'admin.settings.auth.methods.phone.title': '手机号认证',
  'admin.settings.auth.methods.phone.description':
    '控制短信验证码发送、手机号绑定和后续手机号登录能力。',
  'admin.settings.rateLimit.title': '全局限流',
  'admin.settings.rateLimit.requestsPerMinute': '每分钟请求数',
  'admin.settings.rateLimit.windowSeconds': '时间窗口（秒）',
  'admin.settings.toast.quotaUpdated': '配额开关已更新',
  'admin.settings.toast.quotaUpdateFailed': '更新配额开关失败',
  'admin.settings.toast.commerceUpdated': '商业化开关已更新',
  'admin.settings.toast.commerceUpdateFailed': '更新商业化开关失败',
  'admin.settings.toast.solverModeUpdated': '解题器模式已更新',
  'admin.settings.toast.solverModeUpdateFailed': '更新解题器模式失败',
  'admin.settings.toast.memoryUpdated': '记忆上限已更新',
  'admin.settings.toast.memoryUpdateFailed': '更新记忆上限失败',
  'admin.settings.toast.authMethodsUpdated': '认证方式开关已更新',
  'admin.settings.toast.authMethodsUpdateFailed': '更新认证方式开关失败',
  'admin.settings.toast.rateLimitUpdated': '限流配置已更新',
  'admin.settings.toast.rateLimitUpdateFailed': '更新限流配置失败',
  'admin.settings.auditLogs.title': '审计日志',
  'admin.settings.auditLogs.time': '时间',
  'admin.settings.auditLogs.admin': '管理员',
  'admin.settings.auditLogs.action': '操作',
  'admin.settings.auditLogs.allActions': '全部操作',
  'admin.settings.auditLogs.target': '目标',
  'admin.settings.auditLogs.ip': 'IP',
  'admin.settings.auditLogs.details': '详情',
  'admin.settings.auditLogs.empty': '暂无审计日志',
  'admin.settings.auditLogs.exportCsv': '导出 CSV',

  'auth.login.subtitle': '登录你的账号',
  'auth.login.email': '邮箱',
  'auth.login.password': '密码',
  'auth.login.signIn': '登录',
  'auth.login.noAccount': '还没有账号？',
  'auth.login.signUp': '注册',
  'auth.login.demo': '首次使用请先注册，当前无需邮箱验证即可登录',
  'auth.login.registrationSuccess': '注册成功，{email} 现在可以直接登录。',
  'auth.login.emailPasswordUnavailable': '当前未开放邮箱密码登录，请联系管理员启用相应认证方式。',
  'auth.login.registerUnavailable': '平台正在内测中，请联系管理员注册账号',
  'auth.login.loginOnlyDemo': '首次使用请先联系管理员分配测试账号',
  'auth.login.phoneComingSoon': '手机号登录入口已预留，管理员开启并完成短信配置后即可使用。',
  'auth.login.orSocialLogin': '或使用第三方登录',
  'auth.login.orDivider': '或',
  'auth.login.qqLogin': 'QQ 登录',
  'auth.login.wechatLogin': '微信登录',

  'auth.register.title': '创建账号',
  'auth.register.subtitle': '加入 Physics Intelligent Agent',
  'auth.register.name': '姓名',
  'auth.register.namePlaceholder': '张三',
  'auth.register.confirmPassword': '确认密码',
  'auth.register.passwordMismatch': '两次密码不一致',
  'auth.register.strengthWeak': '弱',
  'auth.register.strengthMedium': '中',
  'auth.register.strengthStrong': '强',
  'auth.register.createAccount': '创建账号',
  'auth.register.emailRegistrationUnavailable': '平台正在内测中，暂停自助注册，请联系管理员开通账号。',
  'auth.register.haveAccount': '已有账号？',
  'auth.register.signIn': '去登录',

  'auth.verify.verifying': '正在验证邮箱...',
  'auth.verify.pleaseWait': '请稍候，我们正在验证您的邮箱地址。',
  'auth.verify.successTitle': '邮箱验证成功！',
  'auth.verify.successMessage': '您的邮箱已成功验证，现在可以登录账号了。',
  'auth.verify.goToLogin': '前往登录',
  'auth.verify.errorTitle': '验证失败',
  'auth.verify.codeTitle': '输入验证码',
  'auth.verify.codeSent': '我们已向您的邮箱发送了 6 位验证码。',
  'auth.verify.codeSentTo': '验证码已发送至 {{email}}',
  'auth.verify.codeExpired': '验证码错误或已过期，请重新获取。',
  'auth.verify.submitCode': '验证',
  'auth.verify.noCode': '没有收到验证码？',
  'auth.verify.resendCode': '重新发送',
  'auth.verify.checkEmailTitle': '请查收邮件',
  'auth.verify.checkEmailMessage': '我们已向您的邮箱发送了验证码，请查看邮件。',
  'auth.verify.checkEmailMessageWithAddr': '我们已向 {{email}} 发送了验证码，请查看邮件。',
  'auth.verify.resendButton': '重新发送验证码',
  'auth.verify.resendIn': '重新发送',
  'auth.verify.resendSuccess': '验证码已发送！请查看收件箱。',
  'auth.verify.resendError': '发送失败，请稍后重试。',
  'auth.verify.backToLogin': '返回登录',

  'auth.bind.title': '绑定手机号',
  'auth.bind.subtitle': '为了账号安全，请绑定您的手机号码。',
  'auth.bind.phoneLabel': '手机号',
  'auth.bind.sendCode': '发送验证码',
  'auth.bind.codeSentTo': '验证码已发送至 {{phone}}',
  'auth.bind.resendIn': '重新发送',
  'auth.bind.resendCode': '重新发送验证码',
  'auth.bind.sendError': '发送失败，请稍后重试。',
  'auth.bind.verifyError': '验证码错误或已过期。',
  'auth.bind.successTitle': '绑定成功！',
  'auth.bind.successMessage': '手机号已成功绑定，正在跳转...',

  'auth.forgot.title': '忘记密码',
  'auth.forgot.subtitle': '输入您注册时使用的邮箱，我们将发送重置密码链接。',
  'auth.forgot.email': '邮箱地址',
  'auth.forgot.submit': '发送重置链接',
  'auth.forgot.successTitle': '邮件已发送',
  'auth.forgot.successMessage':
    '如果该邮箱已注册，您将收到一封包含重置密码链接的邮件。请检查收件箱（包括垃圾邮件）。',
  'auth.forgot.backToLogin': '返回登录',
  'auth.forgot.tooFrequent': '请求过于频繁，请稍后重试。',

  'auth.reset.title': '设置新密码',
  'auth.reset.subtitle': '请输入您的新密码。',
  'auth.reset.newPassword': '新密码',
  'auth.reset.confirmPassword': '确认新密码',
  'auth.reset.submit': '重置密码',
  'auth.reset.passwordMismatch': '两次输入的密码不一致',
  'auth.reset.successTitle': '密码已重置',
  'auth.reset.successMessage': '您的密码已成功重置，请使用新密码登录。',
  'auth.reset.goToLogin': '前往登录',
  'auth.reset.invalidToken': '重置链接无效或已过期，请重新申请。',

  'auth.changePassword.title': '修改密码',
  'auth.changePassword.oldPassword': '当前密码',
  'auth.changePassword.newPassword': '新密码',
  'auth.changePassword.confirmPassword': '确认新密码',
  'auth.changePassword.sendCode': '发送验证码',
  'auth.changePassword.codeSent': '验证码已发送到您的邮箱',
  'auth.changePassword.deliveryHint': '修改密码时会向当前登录邮箱发送 6 位验证码：',
  'auth.changePassword.codeLabel': '邮箱验证码',
  'auth.changePassword.codeHint': '请查看邮箱，输入 6 位验证码',
  'auth.changePassword.resendCode': '重新发送',
  'auth.changePassword.submit': '确认修改',
  'auth.changePassword.success': '密码已成功修改',
  'auth.changePassword.mismatch': '两次输入的密码不一致',
  'auth.changePassword.wrongOld': '当前密码不正确',

  'auth.login.forgotPassword': '忘记密码？',
  'errorBoundary.title': '出现了一些问题',
  'errorBoundary.chunkLoadHint':
    '检测到新版本正在加载。如果页面没有自动刷新，请点击“重新加载页面”。',
  'errorBoundary.genericHint': '给你带来不便，抱歉。请尝试刷新页面；如果问题仍然存在，请联系支持。',
  'errorBoundary.tryAgain': '重试',
  'errorBoundary.reloadPage': '重新加载页面',
  'auth.placeholder.email': 'name@example.com',
  'auth.layout.login.quote': '格物致知，叩问自然之理；以AI之力，点亮每一颗求知的心。',
  'auth.layout.login.author': '万象 (OmniPhysics)AI',
  'auth.layout.register.quote': '教育不是灵魂的火焰，而是点燃火焰的火花。',
  'auth.layout.register.author': '苏格拉底',
  'auth.layout.reset.quote': '困难之中，蔽藏着机遇。',
  'auth.layout.reset.author': '爱因斯坦',
  'auth.layout.forgot.quote': 'The only way to do great work is to love what you do.',
  'auth.layout.forgot.author': 'Steve Jobs',
  'auth.socialCallback.signingIn': '正在登录...',

  'usage.daily': '今日对话',
  'usage.upgrade': '查看套餐',

  'notFound.subtitle': '页面不存在',
  'notFound.desc': '你访问的页面不存在。',
  'notFound.back': '返回聊天',

  'chat.welcomeTitle': '欢迎使用万象 (OmniPhysics)AI',
  'chat.welcomeSubtitle': '开始新对话或从侧边栏选择一个对话',
  'chat.startNewChat': '开始新对话',
  'chat.howHelp': '我可以如何帮助你？',
  'chat.placeholder': '提一个物理问题，或使用/发现更多新功能',
  'chat.deepThinking': '深度思考',
  'chat.deepThinkingDefault': '默认',
  'chat.deepThinkingTooltip':
    '启用深度思考模式，让模型进行更深入的推理。需要模型支持（如 DeepSeek）',
  'chat.webSearch': '智能搜索',
  'chat.webSearchTooltip': '启用网络搜索，智能体会在需要时搜索网络信息补充回答',
  'chat.webSearch.unavailableBadge': '未配置',
  'chat.webSearchTooltip.tavily': '启用智能搜索（Tavily）',
  'chat.webSearchTooltip.duckduckgo': '启用智能搜索（DuckDuckGo）',
  'chat.webSearchTooltip.unavailable': '当前后端未启用搜索能力',
  'chat.attachFile': '上传文件',
  'chat.send': '发送',
  'chat.uploadReady': '已就绪',
  'chat.uploading': '上传中…',
  'chat.uploadFailedShort': '上传失败，请移除后重选',
  'chat.uploadFailed': '上传失败',
  'chat.dropFilesHere': '将文件拖到这里',
  'chat.stop': '停止生成',
  'diagnostic.title': '解题验证发现问题',
  'chatMessage.you': '你',
  'chatMessage.copyMessage': '复制消息',
  'chatMessage.copyCode': '复制代码',
  'chatMessage.sources': '参考来源：',
  'chatMessage.sourceN': '来源 {n}',
  'chatMessage.selectedSkills': '已选技能',
  'chatMessage.selectedSkillsPlanned': '已选技能（规划，本轮未调用工具）',
  'chatMessage.forkedSkills': '分叉技能',
  'chatMessage.skill.copilotInteractivePhysics': '交互物理助手 (Copilot Interactive Physics)',
  'chatMessage.skill.teacherLessonPlanning': '教案规划 (Teacher Lesson Planning)',
  'runtimeLabels.selectedSkillsCard': '已选技能',
  'runtimeLabels.allowedToolsCard': '允许工具',
  'runtimeLabels.allowedToolsInline': '允许工具',
  'runtimeLabels.forkTraceTitle': '分叉时间线',
  'runtimeLabels.topToolPrefix': 'Top',
  'runtimeLabels.output': '输出',
  'runtimeLabels.error': '错误',
  'runtimeLabels.step.none': '无步骤',
  'runtimeLabels.step.plan': '规划',
  'runtimeLabels.step.tool': '工具',
  'runtimeLabels.step.finalize': '整理',
  'runtimeLabels.step.clarify': '澄清',
  'runtimeLabels.step.review': '复核',
  'runtimeLabels.step.observe': '观察',
  'runtimeLabels.step.merge': '合并',
  'runtimeLabels.status.completed': '已完成',
  'runtimeLabels.status.running': '进行中',
  'runtimeLabels.status.pending': '等待中',
  'runtimeLabels.status.failed': '失败',
  'runtimeLabels.status.cancelled': '已取消',
  'runtimeLabels.status.interrupted': '已中断',
  'runtimeLabels.fusionMode.nodePolicyIntersectSkillPolicyAndRuntimeAvailability':
    '节点策略 ∩ 技能策略 ∩ 运行时可用性',
  'runtimeLabels.compatibility.compatibilityShim': '兼容适配',
  'runtimeLabels.compatibility.compatibilityOutput': '兼容输出',
  'runtimeLabels.catalogSource.bundled': '内置',
  'runtimeLabels.catalogSource.local': '本地',
  'runtimeLabels.catalogSource.localDir': '本地目录',
  'runtimeLabels.catalogSource.mcp': 'MCP',
  'runtimeLabels.contextMode.fork': 'Fork',
  'runtimeLabels.contextMode.inline': 'Inline',
  'runtimeLabels.capability.toolPolicy': '工具融合策略',
  'runtimeLabels.capability.mcpServers': 'MCP 服务',
  'runtimeLabels.capability.mcpTools': 'MCP 工具',
  'runtimeLabels.capability.mcpPrompts': 'MCP 提示词',
  'runtimeLabels.capability.mcpResources': 'MCP 资源',
  'runtimeLabels.capability.mcpSkillSources': 'MCP 技能来源',
  'runtimeLabels.capability.compatibilityBridge': '兼容桥接',
  'runtimeLabels.capability.preferredField': '首选字段',
  'runtimeLabels.tool.experimentSimulator': '实验模拟器 (Experiment Simulator)',
  'runtimeLabels.tool.guidedSessionInterrupt': '引导式澄清中断 (Guided Session Interrupt)',
  'runtimeLabels.tool.expressionPlot': '表达式绘图 (Expression Plot)',
  'runtimeLabels.tool.numericMotionAnalyzer': '数值运动分析器 (Numeric Motion Analyzer)',
  'runtimeLabels.tool.desmosExport': 'Desmos 导出 (Desmos Export)',
  'runtimeLabels.tool.python': 'Python',
  'runtimeLabels.tool.pythonSandboxInterpreter': 'Python 沙箱解释器 (Python Sandbox Interpreter)',
  'chat.example.newton': '解释牛顿三大运动定律',
  'chat.example.projectile': '如何解抛体运动题？',
  'chat.example.energy': '动能与势能有什么区别？',
  'chat.example.force': '计算加速物体所受的力',
  'chat.actor.student': '学生',
  'chat.actor.teacher': '老师',
  'chat.actor.lockHint': '消息发送期间暂不可切换',
  'chat.actor.switchHint': '切换角色将开始新对话',
  'chat.suggestion.learnConcepts.title': '学习概念',
  'chat.suggestion.learnConcepts.prompt': '用例子解释牛顿三大运动定律',
  'chat.suggestion.solveProblems.title': '解题演练',
  'chat.suggestion.solveProblems.prompt':
    '一个小球以初速度 20 m/s 竖直上抛，求最大高度（忽略空气阻力）',
  'chat.suggestion.em.title': '电磁学',
  'chat.suggestion.em.prompt': '电场强度与电势有什么区别？',
  'chat.suggestion.mechanics.title': '力学',
  'chat.suggestion.mechanics.prompt': '解释角动量守恒，并给出一个典型例子',
  'chat.suggestion.modernPhysics.title': '近代物理',
  'chat.suggestion.modernPhysics.prompt': '解释光电效应，并说明它支持了什么物理观点',
  'chat.suggestion.quantum.title': '量子物理',
  'chat.suggestion.quantum.prompt': '什么是海森堡不确定性原理？它意味着什么？',
  'chat.nav.knowledgeBase': '知识库',
  'chat.nav.agentWorkflow': '智能体工作流',
  'chat.history.loadEarlier': '加载更早消息（剩余 {count} 条）',
  'chat.history.windowHint': '为保持长会话流畅，当前先显示最近 {visible} / {total} 条消息',
  'chat.emptyHint.branch': '该会话的内容可能存在于历史分支中。',
  'chat.emptyHint.missing': '会话内容加载失败：历史记录缺失。',
  'chat.emptyHint.notLoaded': '该会话的内容暂未加载。',
  'chat.emptyHint.openTimeTravel': '打开 Time Travel 面板查看',
  'chat.emptyHint.notRecoverable': '历史数据不可恢复：该会话的原始记录已不存在，无法找回当时的对话内容。',
  'chat.emptyHint.reloadHistory': '重新加载会话内容',
  'chat.scrollToBottom': '回到底部',
  'chat.scrollToBottomUnread': '{count} 条新消息',
  'chat.usage.title': '本次运行的实时 Token 用量',
  'chat.usage.tokens': 'Token',
  'chat.usage.input': '输入',
  'chat.usage.output': '输出',
  'chat.usage.cacheRead': '缓存命中',
  'chat.usage.cacheCreation': '缓存写入',
  'chat.usage.source': '来源',
  'clarification.title': '智能澄清',
  'clarification.sequential.title': '逐步澄清',
  'clarification.recommended': '推荐',
  'clarification.other': '其他',
  'clarification.customPlaceholder': '请输入自定义内容...',
  'clarification.submit': '确认并生成',
  'clarification.submitted': '已提交 ✓',
  'clarification.historyTitle': '澄清问答',
  'clarification.historyQuestions': '{count} 个问题',
  'clarification.historyExpand': '展开',
  'clarification.historyCollapse': '收起',
  'clarification.historyAnswer': '你的回答',
  'clarification.submitting': '提交中...',
  'clarification.next': '下一个问题',
  'chatMessage.ragSource': 'RAG 来源',
  'chatMessage.sourcePreview': '点击查看来源内容',
  'chatMessage.connecting': '正在连接...',
  'mainChat.busBar.view': '查看',
  'mainChat.busBar.remove': '移除',
  'mainChat.clarifyChoice.questionLabel': '问',
  'mainChat.clarifyChoice.answerLabel': '答',
  'chatMessage.thinking.inProgress': '思考中',
  'chatMessage.thinking.inProgressWithTime': '思考中（已用时 {seconds} 秒）',
  'chatMessage.thinking.generating': '生成中',
  'chatMessage.thinking.generatingWithTime': '生成中（已用时 {seconds} 秒）',
  'chatMessage.thinking.completed': '已思考',
  'chatMessage.thinking.completedWithTime': '已思考（用时 {seconds} 秒）',
  'chatMessage.thinking.failed': '失败',
  'chatMessage.thinking.tool': '工具',
  'chatMessage.thinking.args': '参数',
  'chatMessage.thinking.result': '结果',
  'chatMessage.thinking.state': '状态',
  'chatMessage.thinking.reasoning': '思考过程',
  'chatMessage.thinking.toolActivity': '工具活动',
  'chatMessage.thinking.stateSnapshot': '状态快照',
  'chatMessage.thinkingAndOrganizing': '正在思考与整理回答…',
  'chat.model.current': '当前模型',
  'chat.model.currentTitle': '当前模型：{model}',
  'chat.model.currentAria': '当前模型 {model}',
  'chat.model.unsavedChanges': '未保存的更改',
  'chat.researchLauncher': '科研工作台',
  'userMenu.pages': '页面',
  'userMenu.pages.learningSpace': '学习空间',
  'userMenu.pages.researchWorkbench': '科研工作台',
  'userMenu.pages.knowledgeBase': '知识库',
  'workbench.backToChat': '返回主聊天',
  'deepAgent.chat.welcome': '有什么可以帮您？描述任务，我会规划步骤并产出结果。',
  'deepAgent.chat.placeholder': '输入消息…（输入 / 可用斜杠命令）',
  'deepAgent.chat.disclaimer': 'AI 生成内容仅供参考，请自行核验。',
  'deepAgentInline.collapse': '收起',
  'deepAgentInline.expand': '展开',
  'deepAgentInline.close': '关闭 inline 会话',
  'deepAgentInline.endOwnership': '结束 DeepAgent',
  'deepAgentInline.openWorkbench': '打开完整工作台',
  'deepAgentInline.owningBadge': 'inline · 接管中',
  'deepAgentInline.inlineBadge': 'inline session',
  'deepAgentInline.stopRun': '停止',
  'deepAgentInline.stopped': '已停止',
  'deepAgentInline.pauseStream': '暂停显示',
  'deepAgentInline.resumeStream': '继续显示',
  'deepAgentInline.pauseHint': '仅暂停观察屏显示，运行继续',
  'chatMessage.webSearchStatus.executed_empty': '联网检索无结果（零命中）。',
  'chatMessage.webSearchStatus.timeout': '联网检索超时，本轮未采用检索结果。',
  'chatMessage.webSearchStatus.failed': '联网检索失败，本轮未采用检索结果。',
  'chatMessage.webSearchStatus.unavailable': '联网检索不可用（后端未配置）。',
  'chat.toolbar.kb': '对话知识库',
  'chat.toolbar.kbDefaultOption': '默认知识库',
  'chat.toolbar.timeTravelLabel': '时间旅行',
  'chat.toolbar.checkpointsAvailable': '可回放 checkpoint {count} 个',
  'chat.toolbar.timeTravelToggle': '切换 Time Travel 面板',
  'chat.toolbar.timeTravelDesc': 'Time Travel：查看/回放本会话可回放的 checkpoint',
  'chat.model.agentAria': '智能体模型',
  'chat.timeTravel.closeMask': '关闭 Time Travel 面板遮罩',

  // G7-H B4：空聊建议卡（suggestionSpecs id 对应）+ 分支建议
  'chat.suggestions.continue.title': '继续当前交互',
  'chat.suggestions.continue.prompt': '继续当前交互并根据待确认信息推进下一个步骤。',
  'chat.suggestions.vizTune.title': '调参数',
  'chat.suggestions.vizTune.prompt': '请帮我调整当前图像或仿真的参数，并解释变化原因。',
  'chat.suggestions.vizCompare.title': '比较条件',
  'chat.suggestions.vizCompare.prompt': '请比较当前可视化中不同参数条件下的物理差异。',
  'chat.suggestions.vizExport.title': '导出讲义图',
  'chat.suggestions.vizExport.prompt': '请基于当前可视化生成适合讲义展示的图示说明。',
  'chat.suggestions.student-projectile-plot-manim.title': '交互图 + Manim',
  'chat.suggestions.student-projectile-plot-manim.prompt': '生成一个可交互的抛体运动演示图：初速度20m/s、发射角45°、g=9.8m/s²，给出可调参数滑块，并保留 Manim“生成动画”的操作入口。文字尽量简洁，重点展示图表和动画任务状态。',
  'chat.suggestions.student-photoelectric-plot.title': '光电效应图表',
  'chat.suggestions.student-photoelectric-plot.prompt': '画出光电效应中最大初动能 Ek 随入射频率 ν 变化的交互图，逸出功先设为 2.3 eV，并允许我后续调整参数。请用中文简洁解释截止频率和斜率的物理意义。',
  'chat.suggestions.student-socratic-newton.title': '苏格拉底引导',
  'chat.suggestions.student-socratic-newton.prompt': '不要直接告诉我答案，请用苏格拉底式提问一步一步引导我理解牛顿第二定律。每次只问一个关键问题，等我回答后再继续。',
  'chat.suggestions.student-clarify-review-plan.title': '先澄清再规划',
  'chat.suggestions.student-clarify-review-plan.prompt': '我要准备大学物理期末复习，但你先不要直接给方案。先问我3个最关键的澄清问题，再根据我的回答生成复习方案。',
  'chat.suggestions.student-python-verified-solver.title': 'Python 验证解题',
  'chat.suggestions.student-python-verified-solver.prompt': '求解：一个小球以初速度 20 m/s 竖直上抛，g=10 m/s²，最大高度是多少？请给完整物理推导，并用 Python 计算验证关键数值。',
  'chat.suggestions.student-pendulum-experiment.title': '实验与仿真',
  'chat.suggestions.student-pendulum-experiment.prompt': '围绕单摆周期与摆长的关系，设计一个可课堂演示的实验方案，同时给出 PhET 仿真建议和 Phyphox 手机传感器实验步骤。',
  'chat.suggestions.student-error-review-comeback.title': '错题回顾',
  'chat.suggestions.student-error-review-comeback.prompt': '我想回顾之前做错的物理题。请调出错题本，挑一道我最近做错的题，先让我重做一遍，再对比我的答案和参考答案，指出我的概念漏洞。',
  'chat.suggestions.student-weakness-drill.title': '薄弱点专练',
  'chat.suggestions.student-weakness-drill.prompt': '根据我的掌握度数据，找出我当前最薄弱的 1 个物理知识点，出一道难度适中的练习题。我作答后请给详细解析，并追问一道变式题检验我是否真的掌握了。',
  'chat.suggestions.student-concept-map.title': '概念脉络梳理',
  'chat.suggestions.student-concept-map.prompt': '请帮我梳理“功和能”这一章的知识脉络：列出核心概念、它们之间的推导关系，并画一张交互式概念图。标出哪些是我已经问过你的、哪些是还没覆盖的。',
  'chat.suggestions.student-exam-strategy.title': '考试策略',
  'chat.suggestions.student-exam-strategy.prompt': '下周有大学物理期中考试（覆盖运动学、牛顿定律、功能关系）。请帮我制定复习优先级，并针对每块内容给我 1 道典型例题和常见的审题陷阱清单。',
  'chat.suggestions.student-real-world-physics.title': '生活中的物理',
  'chat.suggestions.student-real-world-physics.prompt': '我想知道电磁感应在生活中有哪些真实应用。挑一个我最可能接触到的（比如无线充电），用简单的物理原理讲清楚它为什么能工作，再画一张原理示意图。',
  'chat.suggestions.student-feynman-explain.title': '费曼式输出',
  'chat.suggestions.student-feynman-explain.prompt': '我刚学了动量守恒定律。请听我用我自己的话解释一遍，然后像一位严格的老师一样指出我解释里不严谨或错误的地方，最后给这个解释打分。',
  'chat.suggestions.teacher-lesson-interview.title': '教案访谈',
  'chat.suggestions.teacher-lesson-interview.prompt': '请为大学物理《牛顿第二定律》设计一份40分钟教案，包含教学目标和课堂活动。先通过访谈把年级、学情、教学目标和课堂互动方式问清楚。',
  'chat.suggestions.teacher-discussion-review.title': '讨论链审核',
  'chat.suggestions.teacher-discussion-review.prompt': '请为《电磁感应》设计一条15分钟课堂讨论问题链，生成可用于课堂讨论的产物，并在生成后让我审核通过或修改。',
  'chat.suggestions.teacher-lab-interview.title': '实验课访谈',
  'chat.suggestions.teacher-lab-interview.prompt': '请为大学物理《电磁感应》设计一节90分钟实验课。先通过访谈问清器材条件、学生基础、数据采集方式和评价要求，再生成实验方案。',
  'chat.suggestions.teacher-quiz-generation.title': '测验题组生成',
  'chat.suggestions.teacher-quiz-generation.prompt': '请为《功能关系》生成一份 5 题的小测验：3 道选择题 + 2 道计算题，附答案和评分标准。难度要覆盖基础到进阶，生成后让我逐题审核。',
  'chat.suggestions.teacher-misconception-prep.title': '难点预案',
  'chat.suggestions.teacher-misconception-prep.prompt': '学生学《电磁感应》时通常有哪些典型误解？请列出 5 个最常见的误解、判断依据，以及每个误解对应的课堂澄清策略。',
  'chat.suggestions.teacher-phyphox-design.title': '手机传感器实验',
  'chat.suggestions.teacher-phyphox-design.prompt': '设计一个用 Phyphox 手机传感器做的课后小实验，主题是“测量电梯的加速度”。给出实验步骤、数据记录表格模板和误差分析要点，让学生用手机就能完成。',
  'chat.tasks.expand': '展开任务状态侧栏',
  'chat.tasks.title': '任务状态',
  'chat.tasks.collapse': '收起任务状态侧栏',
  'chat.tasks.retry': '重试该任务',
  'chatMessage.inlineThink.title': '思考过程（模型内联输出）',
  'chatMessage.discussionArtifact': '讨论设计',
  'physicsUi.plotMode.expression': '表达式图 (Expression)',
  'physicsUi.plotMode.parametric': '参数曲线 (Parametric)',
  'physicsUi.plotMode.sampledSeries': '采样序列 (Sampled Series)',
  'physicsUi.plotMode.table': '数据表 (Table)',
  'physicsUi.plotMode.generic': '通用图表 (Generic Plot)',

  // --- Phase 3 i18n residue closure: physicsUi actions ---
  'physicsUi.action.hideVectors': '隐藏矢量',
  'physicsUi.action.showVectors': '显示矢量',
  'physicsUi.action.exportDesmos': '导出 Desmos',
  'physicsUi.action.openDesmos': '打开 Desmos',
  'physicsUi.action.generateAnimation': '生成动画',
  'physicsUi.action.resetDefaults': '恢复默认',
  'physicsUi.action.openLink': '打开链接',
  'physicsUi.action.enableParameter': '开启 {label}',
  'physicsUi.action.disableParameter': '关闭 {label}',

  // --- Phase 3 i18n residue closure: physicsUi animation ---
  'physicsUi.animation.pending': '正在生成动画',
  'physicsUi.animation.open': '打开动画',
  'physicsUi.animation.download': '下载视频',
  'physicsUi.animation.targetDuration': ' · 目标视频 {duration}',
  'physicsUi.animation.estimatedDuration': ' · 预计 {duration}',
  'physicsUi.animation.actualDuration': '视频时长 {duration}',
  'physicsUi.animation.failed': '动画生成失败，已回退到静态讲解。',
  'physicsUi.animation.regenerate': '重新生成动画',
  'physicsUi.animation.expired': '动画视频仅在当前对话中保留，该视频已过期。如需查看请重新生成。',
  'physicsUi.animation.extraLabel': '附加动画',

  // --- Phase 3 i18n residue closure: physicsUi sections ---
  'physicsUi.section.workflowStatus': '流程状态',
  'physicsUi.section.fullProcess': '完整过程',
  'physicsUi.section.fullClarification': '完整澄清记录',
  'physicsUi.section.fullReview': '完整审核记录',

  // --- Phase 3 i18n residue closure: physicsUi code ---
  'physicsUi.code.description': '代码演示与计算结果',
  'physicsUi.code.tab.code': '代码',
  'physicsUi.code.tab.stdout': '输出',
  'physicsUi.code.tab.images': '图像',
  'physicsUi.code.noStdout': '暂无额外输出',
  'physicsUi.code.noImages': '当前代码结果未附带图像资产。',

  'chatMessage.regenerate': '重新生成',
  'chatMessage.feedback.helpful': '有帮助',
  'chatMessage.feedback.notHelpful': '没帮助',
  'chatMessage.timestamp.justNow': '刚刚',

  'settings.title': '设置',
  'settings.subtitle': '管理外观、服务配置与账号信息',
  'settings.tabs.language': '语言设置',
  'settings.tabs.languageDesc': '界面语言与本地化',
  'settings.tabs.model': '模型配置',
  'settings.tabs.modelDesc': '模型绑定与路由策略',
  'settings.tabs.mcp': 'MCP 设置',
  'settings.tabs.mcpDesc': 'MCP 服务运行参数',
  'settings.tabs.skills': '技能设置',
  'settings.tabs.skillsDesc': '技能启用与优先级',
  'settings.tabs.memory': '个人记忆',
  'settings.tabs.mastery': '学习掌握度',
  'settings.tabs.memoryDesc': '管理 AI 记住的个人信息',
  'settings.tabs.masteryDesc': '基于知识追踪与错题复习的学习画像',
  'settings.tabs.myTemplates': '我的教案',
  'settings.tabs.myTemplatesDesc': '查看您生成过的教案和教学内容',
  'settings.myTemplates.title': '我的教案',
  'settings.myTemplates.description': '您生成过的教案、试卷、实验方案等教学内容',
  'settings.myTemplates.empty': '暂无教案记录。在聊天中使用教师模式生成教案后，将自动保存在这里。',
  'settings.myTemplates.state.fallback': '降级产物',
  'settings.tabs.subscription': '订阅套餐',
  'settings.tabs.subscriptionDesc': '升级会员，解锁更多功能',
  'settings.memory.title': '个人记忆',
  'settings.memory.description': 'AI 会参考这些记忆来提供个性化回答。你可以随时添加、编辑或删除。',
  'settings.memory.addTitle': '添加记忆',
  'settings.memory.addPlaceholder': '例如：我是高二学生，偏好用公式推导学物理...',
  'settings.memory.category': '分类',
  'settings.memory.category.general': '通用',
  'settings.memory.category.profile': '个人信息',
  'settings.memory.category.preference': '学习偏好',
  'settings.memory.category.knowledge': '知识水平',
  'settings.memory.category.topic': '学科主题',
  'settings.memory.add': '添加',
  'settings.memory.created': '记忆已添加',
  'settings.memory.updated': '记忆已更新',
  'settings.memory.deleted': '记忆已删除',
  'settings.memory.cleared': '所有记忆已清除',
  'settings.memory.clearConfirm': '确定要清除所有记忆吗？此操作不可撤销。',
  'settings.memory.clearAll': '清除全部',
  'settings.memory.userMemories': '我的记忆',
  'settings.memory.autoMemories': '自动提取的记忆',
  'settings.memory.autoDesc': '这些是 AI 在对话中自动学习到的信息，你可以删除不需要的。',
  'settings.memory.empty': '还没有记忆。添加一些让 AI 更了解你吧！',
  'settings.memory.teachingTitle': '教学记忆',
  'settings.memory.teachingDescription': '保留你当前用于教学与个性化回答的基础记忆管理。',
  'settings.memory.awareness.title': '科研意识系统',
  'settings.memory.awareness.description':
    '在设置页查看科研意识、长期研究记忆、短期工作记忆与操作台动态。高级订阅用户可用。',
  'settings.memory.awareness.enabled': '意识模式',
  'settings.memory.awareness.enabledDesc': '在设置中显示完整科研意识产品页。',
  'settings.memory.awareness.autoRefresh': '自动记忆',
  'settings.memory.awareness.autoRefreshDesc': '自动刷新科研意识与操作台动态。',
  'settings.memory.awareness.refresh': '立即刷新',
  'settings.memory.awareness.openWorkbench': '打开科研工作台',
  'settings.memory.awareness.collapsed': '科研意识页已折叠。重新打开“意识模式”可继续查看完整内容。',
  'settings.memory.awareness.storageTitle': '意识信息',
  'settings.memory.awareness.storageDescription': '稳定人格层、长期真相与短期工作记忆的当前权威来源。',
  'settings.memory.awareness.storageStable': '稳定人格层',
  'settings.memory.awareness.storageLongTerm': '长期研究记忆',
  'settings.memory.awareness.storageShortTerm': '短期工作记忆',
  'settings.memory.awareness.overviewTitle': '意识概览',
  'settings.memory.awareness.overviewDescription': '快速查看协作人格、工作手册、用户画像和长期研究记忆分布。',
  'settings.memory.awareness.longTermTitle': '长期研究记忆',
  'settings.memory.awareness.activityTitle': '进化动态',
  'settings.memory.awareness.activityDescription': '最近的科研短期记忆、快照审查与 follow-up 动态。',
  'settings.memory.awareness.activityEmpty': '当前还没有可展示的科研意识动态。',
  'settings.memory.awareness.trendTitle': '记忆趋势',
  'settings.memory.awareness.trendDescription': '最近 7 天的科研意识活动趋势与核心统计。',
  'settings.memory.awareness.metricShortTerm': '短期记忆',
  'settings.memory.awareness.metricSnapshots': '保留快照',
  'settings.memory.awareness.metricFollowUps': '后续跟进',
  'settings.memory.awareness.dangerTitle': '危险操作',
  'settings.memory.awareness.dangerDescription': '只影响科研工作台的本地短期记忆与推荐历史，不影响教学记忆。',
  'settings.memory.awareness.clearRecommendations': '清空科研推荐历史',
  'settings.memory.awareness.clearProjectMemory': '清空科研短期记忆',
  'settings.memory.awareness.clearOperatorState': '清空操作台状态',
  'settings.memory.awareness.refreshed': '科研意识已刷新',
  'settings.memory.awareness.export': '导出意识包',
  'settings.memory.awareness.import': '导入意识包',
  'settings.memory.awareness.imported': '科研意识包已导入',
  'settings.memory.awareness.clearedRecommendations': '科研推荐历史已清空',
  'settings.memory.awareness.clearedProjectMemory': '科研短期记忆已清空',
  'settings.memory.awareness.clearedOperatorState': '操作台状态已清空',
  'settings.memory.awareness.lockedTitle': '科研意识系统（高级版）',
  'settings.memory.awareness.lockedDescription': '当前账号未开通建模-论文-科研高级功能。',
  'settings.memory.awareness.lockedHint': '升级后可在此页查看 Research Awareness、长期研究记忆、操作台快照与 follow-up。',
  'settings.memory.awareness.upgrade': '升级订阅',
  'settings.memory.awareness.retry': '重新检查权限',
  'settings.appearance.title': '外观',
  'settings.appearance.theme': '主题',
  'settings.appearance.current': '当前生效：{mode}',
  'settings.general.title': '通用',
  'settings.general.workflowEditor': '打开工作流编辑器',
  'settings.general.keepLegacy': '保留旧版设置',
  'settings.general.keepLegacyDesc': '继续启用旧接口与兼容字段',
  'settings.general.shortcuts': '启用快捷键',
  'settings.general.shortcutsDesc': '允许聊天页面使用键盘快捷操作',
  'settings.modules.saved': '设置已保存',
  'settings.confirm.title': '确认保存配置',
  'settings.confirm.general': '保存通用配置并生成新版本快照？',
  'settings.confirm.language': '保存语言配置并写入审计日志？',
  'settings.confirm.model': '保存模型配置并写入审计日志？',
  'settings.confirm.mcp': '保存 MCP 配置并写入审计日志？',
  'settings.confirm.skills': '保存 Skills 配置并写入审计日志？',
  'settings.language.moduleDesc': '设置平台默认语言，并同步前端显示语言。',
  'settings.language.defaultLocale': '默认语言',
  'settings.model.moduleDesc': '控制工作流扫描热更新与节点绑定策略。',
  'settings.model.autoRefresh': '自动刷新扫描结果',
  'settings.model.autoRefreshDesc': '当工作流源码变化时自动更新模型配置需求。',
  'settings.model.bindingStrategy': '默认绑定策略',
  'settings.model.strategy.taskType': '按任务类型（task-type）',
  'settings.model.strategy.nodeId': '按节点 ID（node-id）',
  'settings.model.strategy.manual': '手动绑定（manual）',
  'settings.model.configMovedTitle': '模型提供商配置入口已迁移',
  'settings.model.configMovedDesc':
    '旧版 external-services 模型配置已废弃。请在“设置 → 模型提供商”中管理 OpenAI/Anthropic 及自定义 provider 的五元组配置。',
  'settings.model.configMovedAction': '打开模型提供商',
  'settings.model.configMovedSecondary': '打开模型面板',
  'settings.mcp.moduleDesc': '管理 MCP 服务器连接、鉴权、重试与权限范围。',
  'settings.mcp.add': '新增 MCP 服务器',
  'settings.mcp.serverFallback': 'MCP 服务器 {index}',
  'settings.mcp.reloadCatalog': '重新加载目录',
  'settings.mcp.reloadCatalogSuccess': 'MCP 目录已重新加载',
  'settings.mcp.reloadCatalogFailed': '重新加载 MCP 目录失败',
  'settings.mcp.serversCount': '服务器',
  'settings.mcp.toolsCount': '工具',
  'settings.mcp.promptsCount': '提示词',
  'settings.mcp.resourcesCount': '资源',
  'settings.mcp.runtimeCatalog': '运行时目录',
  'settings.mcp.catalogStatusFallbackOnly': '仅使用回退目录',
  'settings.mcp.catalogStatusActive': 'MCP 已启用',
  'settings.mcp.localServer': '本地',
  'settings.mcp.serverId': '服务器 ID',
  'settings.mcp.displayName': '显示名称',
  'settings.mcp.transport': '传输方式',
  'settings.mcp.transportOption.http': 'HTTP',
  'settings.mcp.transportOption.stdio': '标准输入输出',
  'settings.mcp.transportOption.websocket': 'WebSocket',
  'settings.mcp.transportOption.command': '命令',
  'settings.mcp.endpointOrCommand': '端点或命令',
  'settings.mcp.args': '参数（逗号分隔）',
  'settings.mcp.envRefs': '环境变量引用（${VAR}）',
  'settings.mcp.authType': '认证类型',
  'settings.mcp.authTypeOption.none': '无',
  'settings.mcp.authTypeOption.bearer': 'Bearer',
  'settings.mcp.authTypeOption.basic': 'Basic',
  'settings.mcp.authTypeOption.apiKey': 'API Key',
  'settings.mcp.authTypeOption.oauth': 'OAuth',
  'settings.mcp.authEnvRef': '认证环境变量',
  'settings.mcp.timeoutMs': '超时时间（毫秒）',
  'settings.mcp.rateLimit': '限流（RPS）',
  'settings.mcp.namespace': '命名空间',
  'settings.mcp.permissionScope': '权限范围（逗号分隔）',
  'settings.mcp.refreshPolicy': '刷新策略',
  'settings.mcp.retryMax': '最大重试次数',
  'settings.mcp.retryBackoff': '退避时间（毫秒）',
  'settings.mcp.enabled': '启用该 MCP 服务器',
  'settings.skills.moduleDesc': '管理技能路径、优先级、超时与能力依赖。',
  'settings.skills.add': '新增技能',
  'settings.skills.skillFallback': '技能 {index}',
  'settings.skills.sourceId': '来源 ID',
  'settings.skills.kind': '类型',
  'settings.skills.skillId': '技能 ID',
  'settings.skills.displayName': '显示名称',
  'settings.skills.path': '路径',
  'settings.skills.version': '版本',
  'settings.skills.priority': '优先级',
  'settings.skills.timeoutMs': '超时时间（毫秒）',
  'settings.skills.allowedTools': '允许工具（逗号分隔）',
  'settings.skills.requiredCapabilities': '所需能力（逗号分隔）',
  'settings.skills.namespace': '命名空间',
  'settings.skills.enableFork': '启用分叉',
  'settings.skills.fallbackSkillId': '回退技能 ID',
  'settings.skills.tags': '标签（逗号分隔）',
  'settings.skills.enabled': '启用该技能',
  'settings.skills.reloadCatalog': '重新加载目录',
  'settings.skills.reloadCatalogSuccess': '技能目录已重新加载',
  'settings.skills.reloadCatalogFailed': '重新加载技能目录失败',
  'settings.skills.catalogSize': '目录总数',
  'settings.skills.forkableCount': '可分叉',
  'settings.skills.loadedMode': '加载状态',
  'settings.skills.loadedModeRefreshing': '刷新中',
  'settings.skills.loadedModeReady': '就绪',
  'settings.skills.runtimeCatalog': '运行时目录',
  'settings.skills.executionProbe': '执行探针',
  'settings.skills.executionProbeDesc': '对选中的技能运行一条问题，查看解析后的策略与分叉输出。',
  'settings.skills.downloadRuntimeSnapshot': '下载运行快照',
  'settings.skills.queryLabel': '问题',
  'settings.skills.selectedSkillIds': '已选技能 ID',
  'settings.skills.actorMode': '执行身份',
  'settings.skills.runProbe': '运行探针',
  'settings.skills.runningProbe': '运行中…',
  'settings.skills.runtimeSummaryTitle': '技能运行摘要',
  'settings.skills.runtimeSummaryDesc': '查看探针返回的技能解析、策略与分叉时间线。',
  'settings.skills.defaultNamespace': '默认',
  'settings.skills.executeQueryRequired': '执行问题不能为空',
  'settings.skills.executeSkillRequired': '至少选择一个技能',
  'settings.skills.executeSuccess': '技能执行完成',
  'settings.skills.executeFailed': '技能执行失败',
  'settings.language.title': '语言',
  'settings.account.title': '账号',
  'settings.account.phone.title': '手机号',
  'settings.account.phone.action': '去绑定',
  'settings.account.phone.bound': '已绑定',
  'settings.account.phone.unbound': '未绑定',
  'settings.account.phone.hint': '绑定手机号后可用于第三方登录补全与账号安全校验。',
  'settings.about.title': '关于',
  'settings.about.description': '应用信息与服务配置',
  'settings.about.app': '应用',
  'settings.about.configVersion': '配置版本',
  'settings.about.services': '服务配置',
  'settings.shortcuts.title': '键盘快捷键',
  'settings.shortcuts.newChat': '新建对话',
  'settings.shortcuts.focusInput': '聚焦输入框',
  'settings.shortcuts.searchChats': '搜索对话',
  'settings.shortcuts.cancelClose': '取消 / 关闭',
  'settings.danger.title': '危险操作',
  'settings.danger.signOut.title': '退出登录',
  'settings.danger.signOut.desc': '清除本地登录态并返回登录页',
  'settings.danger.signOut.action': '退出',

  'serviceConfig.title': '服务配置',
  'serviceConfig.agentService': 'Agent 服务',
  'serviceConfig.memoryService': 'Memory 服务',
  'serviceConfig.ragService': 'RAG 服务',
  'serviceConfig.fileService': 'File 服务',
  'serviceConfig.serviceUrl': '服务地址',
  'serviceConfig.legacyTitle': '旧版模型配置',
  'serviceConfig.legacyDesc':
    '兼容旧字段（model_provider / model_name）。新模型路由优先使用“模型配置（external-services）”。',
  'serviceConfig.modelProvider': '模型提供方',
  'serviceConfig.modelProviderPlaceholder': '例如：openai、anthropic',
  'serviceConfig.modelName': '模型名称',
  'serviceConfig.modelNamePlaceholder': '例如：gpt-4、claude-3',
  'serviceConfig.save': '保存配置',
  'serviceConfig.saved': '配置已保存！',

  'modelConfig.title': '模型配置',
  'modelConfig.desc':
    '管理 external-services 配置中的模型条目（local/cloud 模式）。这里主要编辑 endpoint、model、parameters（JSON）。',
  'modelConfig.add.title': '新增条目（服务 ID）',
  'modelConfig.add.placeholder': '例如：qwen3-30b / glm-4-5',
  'modelConfig.add.hint':
    '服务 ID 会作为 YAML 的 key；目前不支持重命名（如需改名建议新增后迁移配置再删除旧条目）。',
  'modelConfig.add.action': '新增',
  'modelConfig.list.empty': '暂无条目，请先新增。',
  'modelConfig.list.default': '默认',
  'modelConfig.list.endpoint': 'endpoint',
  'modelConfig.list.model': 'model',
  'modelConfig.editor.selectPrompt': '请选择一个条目进行编辑。',
  'modelConfig.editor.serviceId': '服务 ID',
  'modelConfig.editor.displayName': '展示名称（name）',
  'modelConfig.editor.displayNamePlaceholder': '例如：Qwen3-30B 语言模型',
  'modelConfig.editor.displayNameHint': '用于 UI 展示；不影响服务 ID（YAML key）。',
  'modelConfig.editor.endpoint': 'Endpoint',
  'modelConfig.editor.endpointPlaceholder': '例如：https://dashscope.aliyuncs.com',
  'modelConfig.editor.modelLabel': 'Model',
  'modelConfig.editor.modelPlaceholder': '例如：Qwen/Qwen3-30B-A3B',
  'modelConfig.editor.parameters': 'Parameters（JSON 对象）',
  'modelConfig.editor.parametersPlaceholder': '例如：{"temperature":0.7,"max_tokens":2048}',
  'modelConfig.editor.parametersHint': '提示：保存前会校验 JSON；如需清空参数，可留空或填写 {}。',
  'modelConfig.editor.enabled': 'Enabled',
  'modelConfig.editor.type': 'Type',
  'modelConfig.editor.typePlaceholder': '例如：ollama / modelscope / zhipuai / http',
  'modelConfig.editor.typeHint': '后端要求 type 必填；不确定时可先用 http。',
  'modelConfig.editor.validateParams': '校验参数 JSON',
  'modelConfig.error.fetchFailed': '获取模型配置失败',
  'modelConfig.error.saveFailed': '保存模型配置失败',
  'modelConfig.addService': '新增',
  'modelConfig.delete': '删除',
  'modelConfig.mode.local': '本地',
  'modelConfig.mode.cloud': '云端',
  'modelConfig.toast.enterId': '请输入服务 ID（例如 qwen3-30b）',
  'modelConfig.toast.duplicateId': '已存在同名条目：{id}',
  'modelConfig.toast.added': '已新增条目（别忘了点击保存）',
  'modelConfig.toast.deleted': '已删除条目（别忘了点击保存）',
  'modelConfig.toast.paramsInvalid': 'parameters JSON 有错误，请修正后再保存',
  'modelConfig.toast.paramsMustObject': 'parameters 必须是 JSON 对象（例如 {"temperature":0.7}）',
  'modelConfig.toast.saved': '模型配置已保存',
  'modelConfig.toast.reset': '已重置为服务器版本（未保存的修改已丢弃）',
  'modelConfig.toast.refreshed': '已刷新',
  'modelConfig.confirmDelete': '确认删除条目 "{id}"？此操作需要点击“保存”后才会写入服务端。',

  'workflow.title': '工作流编辑器',
  'workflow.subtitle': '按节点配置模型绑定、筛选供应商并批量提交',
  'workflow.refreshScan': '刷新扫描',
  'workflow.scanRefreshed': '扫描结果已刷新',
  'workflow.searchTitle': '模型供应商搜索',
  'workflow.catalogCount': '模型 {models} / 配置档 {profiles}',
  'workflow.searchPlaceholder': '按节点、文件、函数或绑定键搜索',
  'workflow.filter.modelType': '类型筛选',
  'workflow.filter.performance': '性能筛选',
  'workflow.filter.cost': '成本筛选',
  'workflow.filter.region': '地区筛选',
  'workflow.batchTitle': '批量配置',
  'workflow.selectedCount': '已选择 {count} 个节点',
  'workflow.selectProfile': '请选择配置档',
  'workflow.applyToSelected': '应用到选中节点',
  'workflow.saveComment': '变更说明',
  'workflow.saveCommentPlaceholder': '可选：说明本次批量修改目的',
  'workflow.clearSelection': '清空选择',
  'workflow.saveSelected': '保存选中节点',
  'workflow.saved': '节点绑定已保存',
  'workflow.emptyCallsites': '未扫描到可配置的模型调用节点。',
  'workflow.graphSummary': '依赖图谱摘要',
  'workflow.graphSummaryValue': '节点 {nodes} · 边 {edges} · 调用点 {callsites}',
  'workflow.selectNode': '选择节点',
  'workflow.primaryProfile': '主配置档',
  'workflow.optionSummary': '{model} / {provider} / ${cost}/1k / {latency}ms / 上下文 {context}',
  'workflow.fallbackProfiles': '备选配置档（逗号分隔）',
  'workflow.timeoutMs': '超时时间（毫秒）',
  'workflow.retryMax': '最大重试次数',
  'workflow.retryBackoff': '退避时间（毫秒）',
  'workflow.scan.sseFallback': '实时扫描连接失败，已降级为手动刷新。',

  // Knowledge Base
  'kb.title': '知识库',
  'kb.refreshList': '刷新列表',
  'kb.noKbs': '暂无知识库',
  'kb.create.title': '创建新知识库',
  'kb.create.idPlaceholder': 'ID (例如 math_kb)',
  'kb.create.namePlaceholder': '名称',
  'kb.create.action': '创建',
  'kb.select.title': '请选择一个知识库',
  'kb.select.desc': '左侧选择或创建一个新的知识库以开始管理',
  'kb.status.enabled': '已启用',
  'kb.status.disabled': '已禁用',
  'kb.refresh': '刷新',
  'kb.delete': '删除',
  'kb.tab.overview': '概览 & 状态',
  'kb.tab.ingest': '文档入库',
  'kb.tab.playground': '检索测试',
  'kb.tab.config': '配置',
  'kb.overview.status': '运行状态',
  'kb.overview.status.ok': '系统正常',
  'kb.overview.status.error': '异常',
  'kb.overview.docCount': '文档数量',
  'kb.overview.chunkCount': 'Chunk 数量',
  'kb.overview.indexSize': '索引大小',
  'kb.overview.monitor': '检索性能监控',
  'kb.overview.fetchMetrics': '拉取最新指标',
  'kb.overview.noMetrics': '暂无指标数据',
  'kb.overview.noDetailedChecks': '暂无详细检查数据',
  'kb.ingest.title': '上传文档',
  'kb.ingest.drop': '拖拽文件到这里，或点击上传',
  'kb.ingest.support': '支持 PDF, TXT, Markdown, Image',
  'kb.ingest.pending': '待上传文件 ({count})',
  'kb.ingest.chunkSize': 'Chunk Size',
  'kb.ingest.overlap': 'Overlap',
  'kb.ingest.concurrency': 'Concurrency',
  'kb.ingest.start': '开始上传并入库',
  'kb.ingest.progress': '任务进度',
  'kb.playground.title': '检索测试',
  'kb.playground.queryLabel': 'Query',
  'kb.playground.queryPlaceholder': '输入检索问题...',
  'kb.playground.vector': '向量检索',
  'kb.playground.hybrid': '混合检索',
  'kb.playground.topK': 'Top K',
  'kb.playground.threshold': 'Threshold',
  'kb.playground.rerank': '启用 Rerank',
  'kb.playground.runVector': '执行向量检索',
  'kb.playground.vectorTopK': 'Vec Top K',
  'kb.playground.keywordTopK': 'Key Top K',
  'kb.playground.rerankTopK': 'Rerank K',
  'kb.playground.results': '结果展示',
  'kb.playground.selectedCount': '已选 {count}',
  'kb.playground.vectorRes': '向量结果',
  'kb.playground.hybridRes': '混合结果',
  'kb.config.title': '基础设置',
  'kb.config.enable': '启用知识库',
  'kb.config.save': '保存配置',
  'kb.config.name': '名称',
  'kb.config.desc': '描述',
  'kb.config.embedding': 'Embedding 配置 (JSON)',
  'kb.config.vectorStore': 'Vector Store 配置 (JSON)',
  'kb.config.rag': 'RAG 参数 (JSON)',
  'kb.config.rerank': 'Rerank 配置 (JSON)',

  // Tooltips
  'tooltip.topK': '检索返回的最相似文档片段数量。',
  'tooltip.scoreThreshold': '相似度分数的最小阈值，低于此分数的文档将被过滤。',
  'tooltip.chunkSize': '文档切片的大小（字符数），影响语义完整性。',
  'tooltip.overlap': '相邻切片之间的重叠字符数，用于保持上下文连贯。',
  'tooltip.concurrency': '并发处理的文件数量，影响入库速度。',
  'tooltip.rerank': '使用重排序模型对检索结果进行二次打分，提高排序准确性。',
  'tooltip.hybridVectorTopK': '混合检索中向量检索返回的 Top K 数量。',
  'tooltip.hybridKeywordTopK': '混合检索中关键词检索返回的 Top K 数量。',
  'tooltip.hybridRerankTopK': '混合检索中最终重排序返回的 Top K 数量。',

  // SubGraphNode

  'pc.unset': '未设置',
  'pc.langgraph-add-node.title': 'LangGraph.add_node 核心参数',
  'pc.langgraph-add-node.desc': '与 StateGraph.add_node 对齐的关键参数',
  'pc.langgraph-add-node.key': '节点唯一键，建议与节点 id 保持一致',
  'pc.langgraph-add-node.runnable': '节点执行体（Runnable/Callable）声明',
  'pc.langgraph-add-node.defer': '是否延迟到 run 末尾再执行',
  'pc.langgraph-add-node.metadata': '节点元数据，会进入 tracing/可观测信息',
  'pc.langgraph-add-node.input_schema': '节点输入 schema（可选）',
  'pc.langgraph-add-node.retry_policy': '重试策略对象（见下方子参数）',
  'pc.langgraph-add-node.cache_policy': '缓存策略对象（见下方子参数）',
  'pc.langgraph-add-node.destinations': '用于可视化目标分支的目的节点提示',
  'pc.langgraph-retry-policy.title': 'LangGraph RetryPolicy',
  'pc.langgraph-retry-policy.desc': '重试细粒度参数',
  'pc.langgraph-retry-policy.initial_interval': '初始重试间隔（秒）',
  'pc.langgraph-retry-policy.backoff_factor': '指数退避系数',
  'pc.langgraph-retry-policy.max_interval': '重试最大间隔（秒）',
  'pc.langgraph-retry-policy.max_attempts': '最大重试次数',
  'pc.langgraph-retry-policy.jitter': '是否启用随机抖动',
  'pc.langgraph-retry-policy.retry_on': '异常过滤器（异常类型或谓词）',
  'pc.langgraph-cache-policy.title': 'LangGraph CachePolicy',
  'pc.langgraph-cache-policy.desc': '缓存策略参数',
  'pc.langgraph-cache-policy.key_func': '缓存 key 生成函数',
  'pc.langgraph-cache-policy.ttl': '缓存 TTL（秒）',
  'pc.langchain-runnable-config.title': 'LangChain RunnableConfig',
  'pc.langchain-runnable-config.desc': '调用时配置（tags/metadata/callbacks 等）',
  'pc.langchain-runnable-config.tags': '运行标签（用于 tracing 与筛选）',
  'pc.langchain-runnable-config.metadata': '运行元数据',
  'pc.langchain-runnable-config.callbacks': '回调处理器',
  'pc.langchain-runnable-config.run_name': '运行名',
  'pc.langchain-runnable-config.max_concurrency': '并发上限',
  'pc.langchain-runnable-config.recursion_limit': '递归调用深度上限',
  'pc.langchain-runnable-config.configurable': '可配置运行参数字典',
  'pc.langchain-runnable-config.run_id': '运行唯一 ID',
  'pc.chat-openai.title': 'LangChain ChatOpenAI 参数',
  'pc.chat-openai.desc': 'OpenAI/兼容端模型参数（核心字段可编辑，其余建议在高级参数中维护）',
  'pc.chat-openai.model_name': '模型名',
  'pc.chat-openai.model': '模型名别名',
  'pc.chat-openai.temperature': '采样温度',
  'pc.chat-openai.max_tokens': '最大输出 token',
  'pc.chat-openai.top_p': '核采样概率',
  'pc.chat-openai.n': '一次采样返回数量',
  'pc.chat-openai.stop': '停止词序列',
  'pc.chat-openai.max_retries': '最大重试次数',
  'pc.chat-openai.request_timeout': '请求超时',
  'pc.chat-openai.presence_penalty': '存在惩罚',
  'pc.chat-openai.frequency_penalty': '频率惩罚',
  'pc.chat-openai.seed': '随机种子',
  'pc.chat-openai.streaming': '是否流式输出',
  'pc.chat-openai.stream_usage': '流式时附带 token usage',
  'pc.chat-openai.reasoning_effort': '推理强度',
  'pc.chat-openai.reasoning': '推理配置',
  'pc.chat-openai.verbosity': '响应详细程度',
  'pc.chat-openai.logprobs': '返回 token logprobs',
  'pc.chat-openai.top_logprobs': '返回前 K 个 logprobs',
  'pc.chat-openai.logit_bias': 'logit 偏置映射',
  'pc.chat-openai.model_kwargs': '透传模型额外参数',
  'pc.chat-openai.extra_body': '额外请求体字段',
  'pc.chat-openai.default_headers': '默认请求头',
  'pc.chat-openai.default_query': '默认 query 参数',
  'pc.chat-openai.include': '响应 include 字段',
  'pc.chat-openai.service_tier': '服务层级',
  'pc.chat-openai.store': '是否持久化请求',
  'pc.chat-openai.truncation': '输入截断策略',
  'pc.chat-openai.use_previous_response_id': '复用上一轮响应 ID',
  'pc.chat-openai.use_responses_api': '是否使用 Responses API',
  'pc.chat-gemini.title': 'LangChain Gemini 参数',
  'pc.chat-gemini.desc': 'Google Gemini 模型参数',
  'pc.chat-gemini.model': '模型名',
  'pc.chat-gemini.temperature': '采样温度',
  'pc.chat-gemini.max_output_tokens': '最大输出 token',
  'pc.chat-gemini.top_p': '核采样概率',
  'pc.chat-gemini.top_k': 'Top-k 采样',
  'pc.chat-gemini.n': '返回候选数',
  'pc.chat-gemini.max_retries': '最大重试次数',
  'pc.chat-gemini.timeout': '请求超时',
  'pc.chat-gemini.response_mime_type': '响应 MIME 类型',
  'pc.chat-gemini.response_schema': '结构化输出 schema',
  'pc.chat-gemini.safety_settings': '安全策略配置',
  'pc.chat-gemini.thinking_budget': '思考预算',
  'pc.chat-gemini.include_thoughts': '是否返回思考内容',
  'pc.chat-gemini.thinking_level': '思考强度级别',
  'pc.chat-gemini.client_args': '底层客户端参数',
  'pc.chat-gemini.model_kwargs': '额外模型参数',
  'pc.chat-ollama.title': 'LangChain Ollama 参数',
  'pc.chat-ollama.desc': 'Ollama 模型参数（核心可编辑 + 常用扩展）',
  'pc.chat-ollama.model': '模型名',
  'pc.chat-ollama.base_url': 'Ollama 服务地址',
  'pc.chat-ollama.temperature': '采样温度',
  'pc.chat-ollama.num_predict': '最大生成 token',
  'pc.chat-ollama.top_k': 'Top-k 采样',
  'pc.chat-ollama.top_p': 'Top-p 采样',
  'pc.chat-ollama.num_ctx': '上下文窗口大小',
  'pc.chat-ollama.repeat_penalty': '重复惩罚',
  'pc.chat-ollama.seed': '随机种子',

  'nodeLib.title': '节点库',
  'nodeLib.template': '模板',
  'nodeLib.create': '新建',
  'nodeLib.remoteCatalog': '后端目录驱动',
  'nodeLib.localFallback': '本地回退（离线可用）',
  'nodeLib.createTemplateHint': '新增模板（相同标识会自动发布新版本）',
  'nodeLib.titlePlaceholder': '模板标题（例如：物理解题器）',
  'nodeLib.keyPlaceholder': '模板标识（留空自动从标题生成）',
  'nodeLib.descPlaceholder': '描述（可选）',
  'nodeLib.defaultsJsonPlaceholder': '默认参数 JSON，例如 {"runnable":{"type":"custom.runner"}}',
  'nodeLib.schemaJsonPlaceholder': '可编辑 Schema JSON，例如 {"type":"object","properties":{}}',
  'nodeLib.saving': '保存中…',
  'nodeLib.saveTemplate': '保存模板',
  'nodeLib.searchPlaceholder': '搜索节点（key/title/desc/category）',
  'nodeLib.cardTooltip': '点击查看节点介绍；拖拽到画布',
  'nodeLib.viewNode': '查看节点介绍',
  'nodeLib.dragToCanvas': '拖拽添加到画布',
  'nodeLib.publishing': '发布中…',
  'nodeLib.newVersion': '新版本',
  'nodeLib.versions': '版本',
  'nodeLib.deleting': '删除中…',
  'nodeLib.versionHistory': '版本历史',
  'nodeLib.noVersions': '暂无版本',
  'nodeLib.err.titleRequired': '模板标题不能为空',
  'nodeLib.err.keyRequired': '模板标识不能为空',
  'nodeLib.err.nodeTypeRequired': '节点类型不能为空',
  'nodeLib.err.invalidDefaultsJson': '默认参数 JSON 不是合法对象',
  'nodeLib.err.invalidSchemaJson': '可编辑 Schema JSON 不是合法对象',
  'nodeLib.toast.versionPublished': '模板新版本已发布',
  'nodeLib.toast.created': '模板已创建',
  'nodeLib.toast.saveFailed': '模板保存失败',
  'nodeLib.toast.keyPublished': '模板 {key} 已发布新版本',
  'nodeLib.toast.publishFailed': '发布新版本失败',
  'nodeLib.toast.loadVersionsFailed': '加载版本失败',
  'nodeLib.toast.keyDeleted': '模板 {key} 已删除',
  'nodeLib.toast.deleteFailed': '删除模板失败',
  'nodeLib.llm.chat.openai': 'OpenAI 兼容聊天模型',
  'nodeLib.llm.chat.anthropic': 'Anthropic Claude 聊天模型',
  'nodeLib.llm.chat.gemini': 'Google Gemini 聊天模型',
  'nodeLib.llm.chat.ollama': '本地/私有部署模型（Ollama）',
  'nodeLib.llm.chat.openai_compatible': '任意 OpenAI 兼容网关',
  'nodeLib.llm.embeddings.openai': '向量嵌入（OpenAI）',
  'nodeLib.llm.embeddings.ollama': '向量嵌入（本地）',
  'nodeLib.agent.deep.planner': 'Deep Agents 规划型代理模板',
  'nodeLib.agent.deep.delegate': 'Deep Agents 被委派执行代理模板',
  'nodeLib.prompt.template': '变量插值 Prompt 模板',
  'nodeLib.prompt.chat': '多角色消息 Prompt',
  'nodeLib.prompt.system': '系统消息片段',
  'nodeLib.prompt.human': '用户消息片段',
  'nodeLib.prompt.few_shot': 'Few-shot 示例 Prompt',
  'nodeLib.prompt.output_parser': '结构化输出解析',
  'nodeLib.retriever.ragflow': 'RAGFlow API 检索（本地部署）',
  'nodeLib.retriever.lightrag': 'LightRAG 知识图谱查询（本地部署）',
  'nodeLib.retriever.vector': '向量检索（TopK，自建 RAG）',
  'nodeLib.retriever.bm25': '关键词检索（BM25，自建 RAG）',
  'nodeLib.retriever.hybrid': '向量 + 关键词混合检索（自建 RAG）',
  'nodeLib.retriever.rerank': '重排序（Xinference Reranker）',
  'nodeLib.retriever.web_search': '联网搜索检索（未实现）',
  'nodeLib.tool.http': '调用 HTTP API',
  'nodeLib.tool.python': 'Python 解释器工具',
  'nodeLib.tool.wolfram': 'Wolfram 计算工具',
  'nodeLib.tool.file_reader': '读取文件/附件内容',
  'nodeLib.tool.json': 'JSON 处理/转换',
  'nodeLib.tool.sql': '数据库查询工具',
  'nodeLib.tool.shell': '受控命令执行（沙箱）',
  'nodeLib.tool.custom': '自定义工具（扩展点）',
  'nodeLib.memory.buffer': '短期对话记忆',
  'nodeLib.memory.summary': '对话摘要记忆',
  'nodeLib.memory.kv': '键值变量存储',
  'nodeLib.memory.checkpoint': '状态检查点（可回放）',
  'nodeLib.memory.thread': '会话线程存储',
  'nodeLib.logic.branch': '条件分支',
  'nodeLib.logic.switch': '多路分发（switch/case）',
  'nodeLib.logic.merge': '合并多路输入',
  'nodeLib.logic.map': '对列表逐项执行',
  'nodeLib.logic.reduce': '聚合/归约',
  'nodeLib.logic.retry': '失败重试策略',
  'nodeLib.logic.guard': '参数校验/断言',
  'nodeLib.logic.subgraph': '子图（可折叠/嵌套）',
  'nodeLib.output.text': '输出文本',
  'nodeLib.output.json': '输出 JSON',
  'nodeLib.output.markdown': '输出 Markdown',
  'nodeLib.output.stream': '流式输出（SSE/Token）',
  'nodeLib.custom.input': '输入节点（自定义）',
  'nodeLib.custom.transform': '自定义数据转换',
  'nodeLib.custom.click': '用户交互触发',
  'nodeLib.custom.runner': '自定义执行器',
  'nodeLib.custom.auth': '鉴权/密钥管理',

  // DynamicNodeForm
  'dnf.modelConfigTip': '请先在全局模型设置中配置模型',
  'dnf.error.jsonObjectRequired': '必须为 JSON 对象',
  'dnf.error.jsonArrayRequired': '必须为 JSON 数组',
  'dnf.error.jsonParseFailed': 'JSON 解析失败',
  'dnf.error.invalidLine': '无效行：{line}',
  'dnf.error.emptyKey': '键不能为空：{line}',
  'dnf.error.required': '{label} 为必填项',
  'dnf.error.mustBeNumber': '{label} 必须为数字',
  'dnf.error.min': '{label} 不能小于 {min}',
  'dnf.error.max': '{label} 不能大于 {max}',
  'dnf.httpBody.json': 'JSON',
  'dnf.httpBody.rawText': '原始文本',
  'dnf.placeholder.rawRequestBody': '原始请求体',
  'dnf.placeholder.responsePath': 'payload.data.items',
  'dnf.placeholder.fromPath': '来源路径',
  'dnf.placeholder.toKey': '目标 key',
  'dnf.placeholder.headerMap': 'Header-A: value\nHeader-B: value',
  'dnf.placeholder.field': '字段名',
  'dnf.placeholder.value': '值',
  'dnf.placeholder.sourceFilter': 'kb, notes',
  'dnf.parseJsonResponse': '解析 JSON 响应',
  'dnf.raiseOnUnexpectedStatus': '异常状态码抛错',
  'dnf.statusHandlers': '状态码策略（Status Handlers）',
  'dnf.noStatusHandlers': '暂无状态码策略。',
  'dnf.extractPathOptional': 'extract path (可选)',
  'dnf.targetKeyOptional': 'target key (可选)',
  'dnf.addStatusHandler': '添加状态码策略',
  'dnf.responseMapping': '响应映射（Response Mapping）',
  'dnf.noMappingRules': '暂无映射规则。',
  'dnf.required': '必填',
  'dnf.addMapping': '添加映射',
  'dnf.noFilterRules': '暂无过滤规则，点击下方按钮添加。',
  'dnf.addRule': '添加规则',
  'dnf.filterStrategy': '过滤策略（Filter Strategy）',
  'dnf.noStructuredFilterRules': '暂无结构化过滤规则。',
  'dnf.addFilterRule': '添加过滤规则',
  'dnf.lightragSearchMode': 'LightRAG 搜索模式（Search Mode）',
  'dnf.lightrag.local': 'Local（局部子图检索）',
  'dnf.lightrag.global': 'Global（全局社区摘要）',
  'dnf.lightrag.hybrid': 'Hybrid（融合 Local + Global）',
  'dnf.lightrag.naive': 'Naive（直接向量检索）',
  'dnf.lightragDesc':
    'Local：从实体关系子图检索；Global：从社区摘要中检索；Hybrid：两者融合；Naive：标准向量相似度。',
  'dnf.ragflowConfig': 'RAGFlow 配置',
  'dnf.ragflowDesc':
    '请在上方「Dataset IDs」字段中填写 RAGFlow 数据集 ID（逗号分隔）。RAGFlow 内部自动处理混合检索。',
  'dnf.fusionStrategy': '融合策略（Fusion / Blend）',
  'dnf.rerankStrategy': '重排序策略（Rerank Strategy）',
  'dnf.enableRerank': '启用重排序',
  'dnf.rerankNodeHint': '当前节点为专用 Rerank 节点，默认启用重排序。',
  'dnf.noRouteMap': '暂无路由映射，点击下方按钮添加。',
  'dnf.noToolsBound': '未绑定工具。勾选下方工具后，模型将通过 Function Calling 自主决定何时调用。',
  'dnf.toolsBound': '已绑定 {count} 个工具 — 模型将自主决定调用时机',
  'dnf.noMessages': '暂无消息，点击下方按钮添加。',
  'dnf.nameOptional': 'name（可选）',
  'dnf.moveUp': '上移',
  'dnf.messageContent': '消息内容',
  'dnf.addMessage': '添加消息',
  'dnf.enable': '启用',
  'dnf.pleaseSelect': '请选择',
  'dnf.modelSelector': '模型选择器',
  'dnf.modelSortHint': '已按节点需求进行推荐排序（能力匹配度、测试状态、本地/云端偏好等）。',
  // DynamicNodeForm — Tool Catalog
  'dnf.tool.python_interpreter.name': 'Python 沙箱解释器',
  'dnf.tool.python_interpreter.desc': '（已退役，请使用 Python 沙箱解释器）',
  'dnf.tool.wolfram_alpha.desc': '符号积分、方程求解、单位换算、物理常数查询',
  'dnf.tool.physics_calculator.name': '物理公式计算器',
  'dnf.tool.physics_calculator.desc': '30+ 物理公式直接计算（力学/电磁/波动/热力学）',
  'dnf.tool.wikipedia.desc': '查询维基百科，获取物理概念、科学家生平、定理历史等知识',
  'dnf.tool.arxiv.name': 'ArXiv 论文检索',
  'dnf.tool.arxiv.desc': '检索 arXiv 物理学/数学/计算机科学学术论文摘要',
  'dnf.tool.duckduckgo.name': 'DuckDuckGo 搜索',
  'dnf.tool.duckduckgo.desc': '免费网络搜索，无需 API Key，适合实时信息检索',
  'dnf.tool.stackexchange.desc': '搜索 Physics / Math StackExchange 问答社区',
  'dnf.tool.wikidata.desc': '结构化知识查询（物理常数、单位定义、实体关系）',
  'dnf.tool.semantic_scholar.desc': '学术论文语义搜索和引用图谱分析',
  'dnf.tool.tavily.name': 'Tavily 搜索',
  'dnf.tool.tavily.desc': 'AI 原生网络搜索引擎，返回结构化搜索结果（需 API Key）',
  'dnf.tool.pubmed.name': 'PubMed 文献检索',
  'dnf.tool.pubmed.desc': '检索生物医学及生物物理交叉学科文献',
  'dnf.tool.nasa.desc': '访问 NASA API 获取天文/太空物理数据和图像',
  'dnf.tool.youtube.name': 'YouTube 搜索',
  'dnf.tool.youtube.desc': '搜索物理教学视频和科普内容',

  'kb.config.modelSelect': '模型选择',
  'kb.config.selectProvider': '选择提供商',
  'kb.config.selectModel': '选择模型',
  'kb.config.baseUrl': 'Base URL',
  'kb.config.timeout': '超时 (秒)',
  'kb.config.concurrency': '并发数',
  'kb.config.provider': '提供商',
  'kb.config.connection': '连接参数 (JSON)',
  'kb.config.chunkSize': 'Chunk Size',
  'kb.config.overlap': 'Overlap',
  'kb.config.topK': 'Top K',
  'kb.config.scoreThreshold': '相似度阈值',
  'kb.config.hybridVectorWeight': '混合检索-向量权重',
  'kb.config.hybridKeywordWeight': '混合检索-关键词权重',
  'kb.config.rerankTopK': 'Top K',
  'kb.config.modelRefreshed': '模型列表已刷新',
  'kb.config.modelRefreshFailed': '刷新模型列表失败',
  'kb.config.refreshModels': '刷新模型列表 (自动发现本地模型)',
  'kb.config.noProviders': '未找到提供商',
  'kb.config.noModels': '未找到模型',
  'kb.config.noModelsHint':
    '未找到模型。请在 设置 > 模型提供商 中配置提供商，或点击刷新按钮以发现本地模型。',

  // Thinking Labels
  'thinkingLabel.node.file_context_enricher': '文件处理',
  'thinkingLabel.node.role_intent': '角色识别',
  'thinkingLabel.node.emotion_analyzer': '情感分析',
  'thinkingLabel.node.skill_router': '技能路由',
  'thinkingLabel.node.teacher_discussion_designer': '讨论设计',
  'thinkingLabel.node.teacher_lesson_planner': '教案规划',
  'thinkingLabel.node.conversation_summarizer': '对话压缩',
  'thinkingLabel.node.error_review': '错题复习',
  'thinkingLabel.node.multimodal': '多模态处理',
  'thinkingLabel.node.intent_classifier': '意图分类',
  'thinkingLabel.node.rag_retrieval': '知识检索',
  'thinkingLabel.node.supervisor': '任务调度',
  'thinkingLabel.node.solver_kernel': '解题内核',
  'thinkingLabel.node.socratic_coach': '苏格拉底引导',
  'thinkingLabel.node.progressive_tutor': '渐进教学',
  'thinkingLabel.node.teacher_review': '教师审核',
  'thinkingLabel.node.student_response_predictor': '学生回答预测',
  'thinkingLabel.node.web_search_fallback': '网络搜索',
  'thinkingLabel.node.sop_extractor': '流程提取',
  'thinkingLabel.node.knowledge_writer': '知识更新',
  'thinkingLabel.node.student_profiler': '学生画像',
  'thinkingLabel.node.knowledge_explainer': '知识讲解',
  'thinkingLabel.node.clarification_planner': '澄清规划',
  'thinkingLabel.node.clarification_batch': '批量澄清',
  'thinkingLabel.node.clarification_ask': '逐步提问',
  'thinkingLabel.node.targeted_generation': '定向生成',
  'thinkingLabel.node.physics_copilot': '物理教练',
  'thinkingLabel.node.capability': '能力检查',
  'thinkingLabel.node.skill_planner': '技能规划',
  'thinkingLabel.node.skill_materializer': '技能装载',
  'thinkingLabel.node.forked_skill_runner': '分叉技能执行',
  'thinkingLabel.node.interactive_model': '交互解答',
  'thinkingLabel.node.model': '模型推理',
  'thinkingLabel.node.copilot_entry': '请求编排',
  'thinkingLabel.node.interactive_tools': '工具执行',
  'thinkingLabel.node.interactive_finalize': '结果整理',
  'thinkingLabel.emotion.frustrated': '沮丧',
  'thinkingLabel.emotion.confused': '困惑',
  'thinkingLabel.emotion.anxious': '焦虑',
  'thinkingLabel.emotion.curious': '好奇',
  'thinkingLabel.emotion.confident': '自信',
  'thinkingLabel.emotion.neutral': '平静',
  'thinkingLabel.strategy.deescalate_and_scaffold': '安抚 + 搭建脚手架',
  'thinkingLabel.strategy.clarify_with_steps': '分步澄清',
  'thinkingLabel.strategy.supportive_guidance': '支持性引导',
  'thinkingLabel.strategy.challenge_with_extension': '拓展挑战',
  'thinkingLabel.strategy.deeper_reasoning': '深层推理',
  'thinkingLabel.strategy.default_socratic': '苏格拉底式引导',
  'thinkingLabel.skill.socratic-scaffold': '苏格拉底脚手架',
  'thinkingLabel.skill.emotion-deescalation': '情绪缓解',
  'thinkingLabel.skill.concept-mapping': '概念映射',
  'thinkingLabel.skill.problem-decomposition': '问题分解',
  'thinkingLabel.skill.metacognitive-prompting': '元认知提示',
  'thinkingLabel.skill.analogical-reasoning': '类比推理',
  'thinkingLabel.skill.visual-representation': '可视化表示',
  'thinkingLabel.skill.error-analysis': '错误分析',
  'thinkingLabel.skill.progressive-hints': '渐进提示',
  'thinkingLabel.skill.real-world-connection': '实际联系',
  'thinkingLabel.skill.knowledge-delivery': '知识传递',
  'thinkingLabel.skill.interactive-clarification': '交互式澄清',
  'thinkingLabel.paramValue.unset': '未设置',

  // Socratic Coaching Interrupt
  'socratic.title': '引导式提问',
  'socratic.round': '第 {current} 步 / 共 {total} 步',
  'socratic.roundEstimated': '第 {current} 步 / 预计 {total} 步',
  'socratic.hint': '💡 提示',
  'socratic.previousQA': '之前的对话',
  'socratic.answerPlaceholder': '输入你的回答...',
  'socratic.submit': '提交回答',
  'socratic.resolved': '已作答',
  'socratic.submitting': '提交中...',
  'socratic.knowledgeReview': '相关知识',
  'socratic.problemContext': '题目背景',

  // Error Review Interrupt
  'errorReview.title': '错题复习',
  'errorReview.knowledgeReview': '知识回顾',
  'errorReview.answerPlaceholder': '输入你的答案...',
  'errorReview.next': '提交并继续',
  'errorReview.finish': '提交并完成',
  'errorReview.submitting': '提交中...',
  'errorReview.correct': '正确',

  // Teacher Interview Interrupt
  'teacher.interview.title': '教学内容设计',
  'teacher.interview.next': '下一个问题',
  'teacher.interview.generate': '开始生成',
  'teacher.interview.customPlaceholder': '请输入自定义内容...',
  'teacher.interview.stale': '本轮会话已结束，此问题卡已失效',
  'teacher.interview.contentType.lesson_plan': '教案设计',
  'teacher.interview.contentType.exam': '试卷设计',
  'teacher.interview.contentType.experiment': '实验方案',
  'teacher.interview.contentType.review': '复习计划',
  'teacher.interview.contentType.general': '教学内容',
  'teacher.review.title': '教师审核',
  'teacher.review.preview': '产物预览',
  'teacher.review.approve': '通过并继续',
  'teacher.review.requestChanges': '退回修改',
  'teacher.review.stop': '中止本次生成',
  'teacher.review.feedbackLabel': '如需退回，请填写修改意见',
  'teacher.review.feedbackPlaceholder': '请输入需要补充、删改或强化的内容...',
  'teacher.review.submitting': '提交中...',
  'teacher.review.contentType.lesson_plan': '教案设计',
  'teacher.review.contentType.discussion': '课堂讨论',
  'teacher.review.contentType.exam': '试卷设计',
  'teacher.review.contentType.experiment': '实验方案',
  'teacher.review.contentType.review': '复习计划',
  'teacher.review.contentType.general': '教学内容',

  // Versioned model settings workspace
  'modelSettings.ui.providerTitle': '模型供应商与部署',
  'modelSettings.ui.workspaceSubtitle': '按供应商管理连接凭证、多个模型部署、模态协议测试和运行时生效状态。保存结果以服务端版本为准。',
  'modelSettings.ui.workspacePreferences': '模型工作区偏好',
  'modelSettings.ui.workspacePreferencesHelp': '这里的自动扫描和默认绑定策略单独保存；不会改动供应商连接或模型部署。',
  'modelSettings.ui.overview': '模型设置概览',
  'modelSettings.ui.connections': '供应商连接',
  'modelSettings.ui.deployments': '模型部署',
  'modelSettings.ui.runtimeActive': '运行中',
  'modelSettings.ui.runtimePending': '等待运行时确认',
  'modelSettings.ui.runtimeFailed': '运行时调用失败',
  'modelSettings.ui.revisionConfig': '配置版本',
  'modelSettings.ui.revisionRuntime': '运行时版本',
  'modelSettings.ui.serverRevision': '服务器版本',
  'modelSettings.ui.filters': '筛选与搜索',
  'modelSettings.ui.filterByModality': '按模型能力筛选',
  'modelSettings.ui.filterAll': '全部能力',
  'modelSettings.ui.searchLabel': '搜索供应商或模型',
  'modelSettings.ui.searchPlaceholder': '搜索供应商、模型名称或编码…',
  'modelSettings.ui.addCustomProvider': '添加自定义供应商',
  'modelSettings.ui.refreshState': '刷新配置状态',
  'modelSettings.ui.loading': '正在读取已保存配置…',
  'modelSettings.ui.noProviders': '没有匹配的供应商。可添加自定义供应商开始配置。',
  'modelSettings.ui.configureProvider': '配置供应商',
  'modelSettings.ui.connectionState': '连接与凭证',
  'modelSettings.ui.testState': '测试收据',
  'modelSettings.ui.runtimeState': '运行时生效',
  'modelSettings.ui.saved': '已保存',
  'modelSettings.ui.notConfigured': '未配置',
  'modelSettings.ui.testsCurrent': '{count} 项测试有效',
  'modelSettings.ui.noCurrentTest': '没有当前有效测试',
  'modelSettings.ui.runtimeActiveCount': '{count} 项已生效',
  'modelSettings.ui.runtimeInactive': '未生效',
  'modelSettings.ui.noDeployments': '尚未添加模型部署',
  'modelSettings.ui.customProviderTitle': '添加自定义 OpenAI 兼容供应商',
  'modelSettings.ui.providerDetailDescription': '在一个供应商下配置连接和多个模型部署。保存、测试与运行时状态分别记录。',
  'modelSettings.ui.errorSummaryTitle': '请检查以下问题',
  'modelSettings.ui.draftRevisionConflict': '另一标签页已更新模型配置，请关闭后重新打开以加载最新版本。',
  'modelSettings.ui.connectionHeading': '供应商连接与密钥',
  'modelSettings.ui.connectionHelp': '每个连接保存自己的服务地址和凭证；留空密钥表示沿用已保存凭证。',
  'modelSettings.ui.addConnection': '添加连接',
  'modelSettings.ui.connection': '连接',
  'modelSettings.ui.baseUrl': '服务地址',
  'modelSettings.ui.apiKey': 'API 密钥',
  'modelSettings.ui.apiKeyHelp': '密钥不会回显；输入新值会替换该连接凭证。',
  'modelSettings.ui.savedKeyPlaceholder': '已保存（末四位 {last4}），留空保持不变',
  'modelSettings.ui.newKeyPlaceholder': '输入 API 密钥（可留空）',
  'modelSettings.ui.savedCredential': '凭证已保存在服务端',
  'modelSettings.ui.noSavedCredential': '尚未保存凭证',
  'modelSettings.ui.removeConnection': '移除连接',
  'modelSettings.ui.removeConnectionBlocked': '该连接仍绑定模型部署，请先解绑模型。',
  'modelSettings.ui.customProviderHelp': '使用 OpenAI 兼容 API 的自定义供应商。凭证仅由获批的服务端连接使用。',
  'modelSettings.ui.providerCode': '供应商编码',
  'modelSettings.ui.providerName': '供应商名称',
  'modelSettings.ui.deploymentsHeading': '模型部署',
  'modelSettings.ui.deploymentsHelp': '同一供应商可为对话、看图、Embedding、Rerank 和生图配置不同模型。',
  'modelSettings.ui.discoverModels': '发现模型',
  'modelSettings.ui.discoveryResult': '目录刷新完成，发现 {count} 个模型。',
  'modelSettings.ui.discoveryFailed': '模型发现失败，请检查连接和服务状态后重试。',
  'modelSettings.ui.catalogModelCount': '可选模型目录：{count} 项',
  'modelSettings.ui.addDeployment': '添加模型部署',
  'modelSettings.ui.noDeploymentsInDrawer': '此供应商尚无模型部署。',
  'modelSettings.ui.newDeployment': '新模型部署',
  'modelSettings.ui.modelName': '模型名称',
  'modelSettings.ui.modelNamePlaceholder': '选择目录模型或输入供应商模型 ID',
  'modelSettings.ui.modality': '模型能力',
  'modelSettings.ui.enabled': '启用部署',
  'modelSettings.ui.defaultBinding': '设为该能力的默认部署',
  'modelSettings.ui.parametersFor': '{modality}参数',
  'modelSettings.ui.protocol': '适配协议',
  'modelSettings.ui.testUnsaved': '未保存的配置',
  'modelSettings.ui.testConnection': '测试连接',
  'modelSettings.ui.testProtocol': '离线验证模型协议',
  'modelSettings.ui.testVerified': '测试通过',
  'modelSettings.ui.testContractValidated': '离线协议已验证',
  'modelSettings.ui.testFailed': '测试失败',
  'modelSettings.ui.testUnsupported': '暂不支持测试',
  'modelSettings.ui.testUntested': '未测试',
  'modelSettings.ui.testStale': '配置已变更，测试已过期',
  'modelSettings.ui.saveBeforeTest': '请先保存配置，再运行测试。',
  'modelSettings.ui.offlineOnlyHint': '当前仅在本地验证模型协议，不会向供应商发送请求。',
  'modelSettings.ui.protocolUnsupported': '此图片模型的调用协议尚未验证，暂不能测试或调用。',
  'modelSettings.ui.temperature': '温度（temperature）',
  'modelSettings.ui.maxTokens': '最大输出 token 数',
  'modelSettings.ui.extraParams': '额外参数（JSON 对象）',
  'modelSettings.ui.extraParamsHelp': '高级供应商参数以 JSON 对象保存；无效 JSON 会阻止保存。',
  'modelSettings.ui.dimensions': '向量维度',
  'modelSettings.ui.batchSize': '批处理大小',
  'modelSettings.ui.topN': '返回结果数（top_n）',
  'modelSettings.ui.returnDocuments': '返回文档内容',
  'modelSettings.ui.imageSize': '图片尺寸',
  'modelSettings.ui.recommendedImageSizes': '可自定义宽 × 高；下拉建议值来自供应商官方推荐。',
  'modelSettings.ui.steps': '推理步数',
  'modelSettings.ui.guidanceScale': '提示引导强度',
  'modelSettings.ui.seed': '随机种子',
  'modelSettings.ui.watermark': '添加水印',
  'modelSettings.ui.aspectRatio': '宽高比',
  'modelSettings.ui.promptOptimizer': '启用提示词优化',
  'modelSettings.ui.duration': '时长（秒）',
  'modelSettings.ui.removeDeployment': '移除部署',
  'modelSettings.ui.save': '保存模型配置',
  'modelSettings.ui.saving': '正在保存…',
  'modelSettings.ui.cancel': '取消',
  'modelSettings.ui.discardDraftConfirm': '关闭将丢弃尚未保存的草稿，确定继续吗？',
  'modelSettings.ui.errorProviderCode': '编码须以字母或数字开头，且只能包含小写字母、数字、下划线和连字符。',
  'modelSettings.ui.errorProviderName': '请输入供应商名称。',
  'modelSettings.ui.errorBaseUrl': '请输入不含用户名和密码的有效 HTTP 或 HTTPS 地址。',
  'modelSettings.ui.errorModelName': '请输入模型名称。',
  'modelSettings.ui.errorConnection': '请选择一个有效的供应商连接。',
  'modelSettings.ui.errorExtraParams': '请输入有效的 JSON 对象，例如 {"top_p":0.8}。',
  'modelSettings.ui.errorSettingsNotLoaded': '当前配置尚未从服务端加载，加载完成后再保存。',
  'modelSettings.ui.errorSave': '保存模型配置失败，请检查后重试。',
  'modelSettings.ui.errorTest': '模型测试失败，请检查连接后重试。',
  'modelSettings.ui.modality.chat': '对话',
  'modelSettings.ui.modality.vision_input': '看图',
  'modelSettings.ui.modality.embedding': 'Embedding 向量化',
  'modelSettings.ui.modality.rerank': 'Rerank 重排序',
  'modelSettings.ui.modality.image_generation': '生图',
  'modelSettings.ui.modality.video_generation': '视频生成',
  'modelSettings.ui.modality.tts': '语音合成',
  'modelSettings.ui.modality.speech2text': '语音识别',
  'modelSettings.ui.modality.moderation': '内容审核',
  'modelSettings.ui.providerCategory.cloud-hosted': '云端托管',
  'modelSettings.ui.providerCategory.local-selfhosted': '本地自托管',
  'modelSettings.ui.providerCategory.openai-compatible': 'OpenAI 兼容',
  'modelSettings.ui.providerCategory.custom': '自定义',
  'modelSettings.ui.defaultTag': '默认',

  // Model Provider Center
  'modelProvider.cap.all': '全部',
  'modelProvider.cap.llm': 'LLM 大语言模型',
  'modelProvider.cap.embedding': 'Embedding 向量化',
  'modelProvider.cap.rerank': 'Rerank 重排序',
  'modelProvider.cap.vision': 'Vision 视觉',
  'modelProvider.cap.tts': 'TTS 语音',
  'modelProvider.title': '模型供应商管理',
  'modelProvider.subtitle':
    '配置模型供应商并测试连通性。测试通过的供应商可在工作流编辑器、知识库中选用。',
  'modelProvider.catalogCount': '目录',
  'modelProvider.configuredCount': '已配置',
  'modelProvider.testedCount': '测试通过',
  'modelProvider.fallbackHint': '（使用前端最小目录回退）',
  'modelProvider.autoDetect': '自动检测模型',
  'modelProvider.autoDetectTitle': '扫描所有已测试通过的供应商，自动发现可用模型',
  'modelProvider.autoDetectNoProviders': '没有已测试通过的供应商，请先配置并测试至少一个供应商',
  'modelProvider.autoDetectSuccess': '已扫描 {count} 个供应商的可用模型',
  'modelProvider.autoDetectFailed': '自动检测模型失败',
  'modelProvider.refresh': '刷新',
  'modelProvider.refreshTitle': '刷新供应商目录与已保存配置',
  'modelProvider.searchPlaceholder': '搜索供应商名称、provider_code 或能力标签…',
  'modelProvider.noMatch': '未匹配到供应商，请调整搜索词或切换能力分类筛选。',
  'modelProvider.itemCount': '{count} 项',
  'modelProvider.registryTitle': '模型仓库中心',
  'modelProvider.registrySubtitle':
    '自动扫描 + 预集成模型元数据（ModelScope / HuggingFace / Ollama）',
  'modelProvider.refreshModels': '刷新模型目录',
  'modelProvider.compareSelected': '对比所选模型',
  'modelProvider.compareMax': '最多对比 3 个模型',
  'modelProvider.searchModels': '搜索模型/标签/能力',
  'modelProvider.allCategories': '全部分类',
  'modelProvider.capabilityFilter': '能力（如 chat/tool_calling）',
  'modelProvider.tagFilter': '标签（如 cn_optimized）',
  'modelProvider.localOnly': '仅本地',
  'modelProvider.testedOnly': '仅已测试通过',
  'modelProvider.modelCount': '当前模型数：{count}；已选对比：{selected}/3',
  'modelProvider.deployLocal': '本地（Ollama）',
  'modelProvider.deployCloud': '云端',
  'modelProvider.testedOk': '已测试通过',
  'modelProvider.notTested': '未测试/未绑定',
  'modelProvider.selected': '已选',
  'modelProvider.addCompare': '加入对比',

  // Model Provider Card
  'modelProvider.card.testProtocol': '测试协议',
  'modelProvider.card.noTestProtocol': '暂不支持测试协议',
  'modelProvider.card.testable': '可测试（{protocol}）',
  'modelProvider.card.statusTested': '已测试通过',
  'modelProvider.card.statusIncomplete': '配置不完整',
  'modelProvider.card.statusUntested': '未测试',
  'modelProvider.card.unfavorite': '取消收藏',
  'modelProvider.card.favorite': '收藏置顶',
  'modelProvider.card.apiKeySaved': '已保存',
  'modelProvider.card.apiKeySavedMask': '已保存（****{last4}）',
  'modelProvider.card.apiKeyNotSet': '未设置',
  'modelProvider.card.lastTest': '最近测试',
  'modelProvider.card.settings': '设置',
  'modelProvider.card.testConnection': '测试连接',
  'modelProvider.card.testTitle': '使用当前已保存配置或推荐默认值测试连接',
  'modelProvider.card.testUnsupportedTitle': '请先选择支持测试协议的供应商',
  'modelProvider.card.noTestHint': '暂不支持测试协议（仅可保存配置）',
  'modelProvider.card.noTestHintDetail': '该供应商当前仅支持保存配置，暂不支持真实连接测试',

  // Model Provider Editor Drawer
  'modelProvider.editor.desc':
    '供应商配置（推荐默认值 + 预集成模型下拉 + 自定义模型）。测试连接为真实请求；',
  'modelProvider.editor.noApiKeyNeeded': '该供应商通常无需 API Key。',
  'modelProvider.editor.apiKeyReuse': 'api_key 留空表示沿用已保存密钥。',
  'modelProvider.editor.apiKeyPlaceholderNone': '本地模型通常无需 API Key（可留空）',
  'modelProvider.editor.apiKeyPlaceholderSaved': '已保存{mask}，留空表示不修改',
  'modelProvider.editor.apiKeyPlaceholderNew': '请输入 API Key（留空表示未设置）',
  'modelProvider.editor.apiKeyHintNone':
    '本地模型通常无需密钥；如你的代理服务需要鉴权，可在此填写。',
  'modelProvider.editor.apiKeyHintRequired':
    '为安全起见不回填明文；如需更新密钥请输入新值。留空表示沿用本地/后端已保存密钥。',
  'modelProvider.editor.discoverOllama': '发现本地模型',
  'modelProvider.editor.discoverOllamaTitle': '发现本地模型（Ollama /api/tags）',
  'modelProvider.editor.refreshModels': '刷新模型目录',
  'modelProvider.editor.refreshModelsTitle': '刷新该供应商模型目录',
  'modelProvider.editor.toggleCustomTitle': '切换添加模型（手动输入）模式',
  'modelProvider.editor.useDropdown': '使用下拉',
  'modelProvider.editor.addModel': '添加模型',
  'modelProvider.editor.searchModel': '搜索或输入模型名',
  'modelProvider.editor.customModelHint':
    '当前为"添加模型"模式。建议先测试连接；测试成功后会自动加入可用模型目录。',
  'modelProvider.editor.modelInfoTitle': '模型能力与默认参数（按当前供应商模型配置）',
  'modelProvider.editor.categories': '分类',
  'modelProvider.editor.capabilities': '能力',
  'modelProvider.editor.contextWindow': '上下文窗口',
  'modelProvider.editor.maxOutput': '最大输出',
  'modelProvider.editor.tokens': '{count} tokens',
  'modelProvider.editor.notProvided': '未提供',
  'modelProvider.editor.reasoning': '推理能力',
  'modelProvider.editor.toolCalling': '工具调用',
  'modelProvider.editor.visionInput': '视觉输入',
  'modelProvider.editor.supported': '支持',
  'modelProvider.editor.unsupported': '未知/不建议',
  'modelProvider.editor.visionNo': '否/未知',
  'modelProvider.editor.recommendedTemp': '推荐 temperature',
  'modelProvider.editor.recommendedMaxTokens': '推荐 max_tokens',
  'modelProvider.editor.recommendedExtra': '推荐高级参数',
  'modelProvider.editor.notes': '说明',
  'modelProvider.editor.paramSource': '参数来源',
  'modelProvider.editor.tuningEnabled': '已启用',
  'modelProvider.editor.tuningDisabled': '未启用',
  'modelProvider.editor.advancedTitle': '高级参数（模型专属）',
  'modelProvider.editor.advancedDesc':
    '以下参数依据当前供应商/模型推断或模型目录元数据生成；保存后写入 extra_params。',
  'modelProvider.editor.testProtocolLabel': '测试协议',
  'modelProvider.editor.testNotSupported': '暂不支持',
  'modelProvider.editor.authModeLabel': '认证模式',
  'modelProvider.editor.authNone': '无需 API Key',
  'modelProvider.editor.authOptional': '可选 API Key',
  'modelProvider.editor.authRequired': '需要 API Key',
  'modelProvider.editor.discovery': '自动发现',
  'modelProvider.editor.saved': '已保存',
  'modelProvider.editor.testConnection': '测试连接',
  'modelProvider.editor.testTitle': '真实连通性测试',
  'modelProvider.editor.testUnsupportedTitle':
    '暂不支持测试协议（请先至【全局模型配置】页完成模型接入）',
  'modelProvider.editor.testPassedCustom': '测试通过，已加入可用模型目录',
  'modelProvider.editor.testPassed': '测试通过',
  'modelProvider.editor.save': '保存',
  'modelProvider.editor.noTestHint':
    '请先至【全局模型配置】页完成模型接入（当前供应商暂不支持测试协议）',

  'tooltip.baseUrl': '可选的 API Base URL',
  'tooltip.timeout': '请求超时时间（秒）',
  'tooltip.modelConcurrency': '最大并发请求数',
  'tooltip.vectorStoreProvider': '向量数据库提供商',
  'tooltip.vectorStoreConnection': '连接参数（JSON 格式）',
  'tooltip.hybridVectorWeight': '混合检索中向量检索的权重',
  'tooltip.hybridKeywordWeight': '混合检索中关键词检索的权重',
  'tooltip.rerankTopK': '重排序后返回的结果数量',

  // Subscription
  'subscription.loadError': '加载订阅信息失败',
  'subscription.currentPlan': '当前套餐',
  'subscription.currentPlanBadge': '当前套餐',
  'subscription.validUntil': '有效期至 {date}',
  'subscription.planName.free': '免费版',
  'subscription.planName.pro': '专业版',
  'subscription.planName.max': '旗舰版',
  'subscription.monthly': '月付',
  'subscription.yearly': '年付',
  'subscription.yearlySave': '省 20%',
  'subscription.popular': '最受欢迎',
  'subscription.free': '免费',
  'subscription.freePlan': '当前套餐',
  'subscription.perMonth': '月',
  'subscription.perYear': '年',
  'subscription.billedYearly': '年付合计 ¥{total}',
  'subscription.upgrade': '立即升级',
  'subscription.purchaseSuccess': '订阅成功！',
  'subscription.purchaseError': '购买失败，请稍后重试',
  'subscription.paymentPending': '订单已创建，支付功能即将上线',
  'subscription.paymentExpired': '订单已关闭，请重新创建支付订单',
  'subscription.paymentStatusError': '刷新订单状态失败，请稍后重试',
  'subscription.note': '订阅到期后将自动降级为免费版。支付功能即将接入，敬请期待。',
  'subscription.bestFor': '适用场景',
  'subscription.planSummary.free': '适合初次体验、轻量问答与基础课程试用',
  'subscription.planSummary.pro': '适合个人教师日常备课与高频答疑',
  'subscription.planSummary.max': '适合课程共建、长上下文推演与高频使用',
  'subscription.compare.title': '套餐对比',
  'subscription.compare.subtitle': '按价格、模型权限和配额快速对比三档套餐。',
  'subscription.compare.metric': '对比项',
  'subscription.compare.bestFor': '适用场景',
  'subscription.compare.monthlyPrice': '月付价格',
  'subscription.compare.yearlyPrice': '年付价格',
  'subscription.compare.modelAccess': '模型权限',
  'subscription.compare.dailyMessages': '每日对话',
  'subscription.compare.contextLength': '上下文长度',
  'subscription.compare.knowledgeBases': '知识库数量',
  'subscription.compare.fileSize': '文件上传',
  'subscription.compare.deepThinking': '深度思考',
  'subscription.compare.priorityResponse': '优先响应',
  'subscription.compare.included': '支持',
  'subscription.compare.notIncluded': '不支持',
  'subscription.compare.unlimited': '无限制',
  'subscription.features.basicModel': '基础模型访问',
  'subscription.features.modelsCount': '{count} 个高级模型访问',
  'subscription.features.allModels': '全部模型访问',
  'subscription.features.dailyMessages': '每日 {count} 次对话',
  'subscription.features.unlimitedMessages': '无限次对话',
  'subscription.features.contextLength': '{length} 上下文长度',
  'subscription.features.knowledgeBases': '{count} 个知识库',
  'subscription.features.unlimitedKb': '无限知识库',
  'subscription.features.fileSize': '最大 {size}MB 文件上传',
  'subscription.features.deepThinking': '深度思考模式',
  'subscription.features.priorityResponse': '优先响应',
  'subscription.usage.title': '今日用量',
  'subscription.usage.messages': '对话 {used}/{limit}',
  'subscription.usage.unlimited': '对话 {used} 次（无限制）',
  'subscription.usage.remaining': '剩余 {count} 次',
  'subscription.usage.exhausted': '今日额度已用尽',
  'subscription.usage.upgrade': '升级套餐',

  'subscription.orders.title': '订单历史',
  'subscription.orders.empty': '暂无订单记录',
  'subscription.orders.orderNo': '订单号',
  'subscription.orders.plan': '套餐',
  'subscription.orders.amount': '金额',
  'subscription.orders.status': '状态',
  'subscription.orders.date': '日期',
  'subscription.orders.status.pending': '待支付',
  'subscription.orders.status.paid': '已支付',
  'subscription.orders.status.cancelled': '已取消',
  'subscription.orders.status.expired': '已过期',
  'subscription.annualSave': '省 {pct}%',
  'subscription.paymentDialog.title': '支付订单',
  'subscription.paymentDialog.description': '请在新窗口或扫码完成支付，页面会自动刷新订单状态。',
  'subscription.paymentDialog.orderNo': '订单号',
  'subscription.paymentDialog.amount': '支付金额',
  'subscription.paymentDialog.plan': '套餐',
  'subscription.paymentDialog.status': '订单状态',
  'subscription.paymentDialog.qrAlt': '支付二维码',
  'subscription.paymentDialog.noQr': '当前订单尚未返回二维码，可直接打开支付页面继续支付。',
  'subscription.paymentDialog.paymentLink': '支付链接',
  'subscription.paymentDialog.openPayment': '打开支付页面',
  'subscription.paymentDialog.copyLink': '复制支付链接',
  'subscription.paymentDialog.copySuccess': '支付链接已复制',
  'subscription.paymentDialog.copyError': '复制支付链接失败',
  'subscription.paymentDialog.refresh': '刷新支付状态',
  'subscription.paymentDialog.pollHint': '支付完成后会自动轮询，也可以手动刷新。',

  // Quota exceeded
  // P0-B POLICY-2：C off（商业面关闭）时的非诱导措辞（Q on 为管理员显式限制）
  'quota.dailyMessagesNoCommerce': '今日对话次数已用完（{limit}次/天），请明天再试',
  'quota.modelAccessNoCommerce': '当前套餐不支持使用模型 {model}',
  'quota.fileSizeNoCommerce': '文件大小超过当前限制（{max}MB）',
  'quota.kbCountNoCommerce': '知识库数量已达上限（{max}个）',
  'quota.contextLengthNoCommerce': '上下文长度超过当前限制（{max}），请缩短对话',
  'quota.featureNoCommerce': '当前套餐未包含此功能',
  'quota.genericExceededNoCommerce': '当前操作已触发限制，请调整后重试',
  'quota.dailyMessages': '今日对话次数已用完（{limit}次/天），请升级套餐或明天再试',
  'quota.dailyMessagesFallback': '今日对话次数已达上限，请升级套餐或明天再试',
  'quota.modelAccess': '当前套餐不支持使用模型 {model}，请升级套餐',
  'quota.modelAccessFallback': '当前套餐不支持使用该模型，请升级套餐',
  'quota.fileSize': '文件大小超过当前套餐限制（{max}MB），请升级套餐',
  'quota.fileSizeFallback': '文件大小超过当前套餐限制，请升级套餐',
  'quota.kbCount': '知识库数量已达上限（{max}个），请升级套餐',
  'quota.kbCountFallback': '知识库数量已达上限，请升级套餐',
  'quota.contextLength': '上下文长度超过当前套餐限制（{max}），请升级套餐或缩短对话',
  'quota.contextLengthFallback': '上下文长度超过当前套餐限制，请升级套餐或缩短对话',
  'quota.feature': '当前套餐不支持此功能，请升级套餐',
  'quota.genericExceeded': '当前操作已触发套餐限制，请升级后重试',

  // Dashboard i18n fix
  'admin.dashboard.autoRefresh': '自动刷新',

  // Admin Bug Reports
  'admin.sidebar.bugReports': 'Bug 反馈',
  'admin.bugs.title': 'Bug 反馈管理',
  'admin.bugs.subtitle': '查看和处理用户提交的 Bug 报告',
  'admin.bugs.table.id': 'ID',
  'admin.bugs.table.title': '标题',
  'admin.bugs.table.user': '用户',
  'admin.bugs.table.severity': '严重程度',
  'admin.bugs.table.status': '状态',
  'admin.bugs.table.createdAt': '提交时间',
  'admin.bugs.table.actions': '操作',
  'admin.bugs.status.open': '待处理',
  'admin.bugs.status.read': '已读',
  'admin.bugs.status.in_progress': '处理中',
  'admin.bugs.status.resolved': '已解决',
  'admin.bugs.status.closed': '已关闭',
  'admin.bugs.severity.low': '低',
  'admin.bugs.severity.medium': '中',
  'admin.bugs.severity.high': '高',
  'admin.bugs.severity.critical': '严重',
  'admin.bugs.action.markRead': '标记已读',
  'admin.bugs.action.resolve': '标记已解决',
  'admin.bugs.action.updateNotes': '更新备注',
  'admin.bugs.action.viewDetail': '查看详情',
  'admin.bugs.action.saveNotes': '保存备注',
  'admin.bugs.filter.all': '全部',
  'admin.bugs.filter.unread': '未读',
  'admin.bugs.filter.status': '状态',
  'admin.bugs.filter.severity': '严重程度',
  'admin.bugs.filter.search': '搜索 Bug 报告...',
  'admin.bugs.filter.searchBtn': '搜索',
  'admin.bugs.empty': '暂无 Bug 报告',
  'admin.bugs.toast.markedRead': '已标记为已读',
  'admin.bugs.toast.resolved': '已标记为已解决',
  'admin.bugs.toast.updateFailed': '操作失败',
  'admin.bugs.toast.updated': '状态已更新',
  'admin.bugs.toast.notesSaved': '备注已保存',
  'admin.bugs.detail.adminNotes': '管理员备注',
  'admin.bugs.detail.adminNotesPlaceholder': '添加内部备注...',
  'admin.bugs.detail.status': '状态',
  'admin.bugs.detail.severity': '严重程度',
  'admin.bugs.detail.description': '详细描述',
  'admin.bugs.detail.steps': '复现步骤',
  'admin.bugs.detail.screenshots': '截图',
  'admin.bugs.detail.submittedBy': '提交者',
  'admin.bugs.detail.pageUrl': '页面地址',
  'admin.bugs.detail.browserInfo': '浏览器信息',
  'admin.bugs.detail.browser': '浏览器',
  'admin.bugs.detail.changeStatus': '更改状态',
  'admin.bugs.detail.user': '用户',
  'admin.bugs.detail.created': '创建时间',
  'admin.bugs.detail.resolvedAt': '解决时间',
  'admin.bugs.detail.resolvedBy': '解决者',
  'admin.bugs.detail.save': '保存',
  'admin.bugs.unreadCount': '{count} 条未读',
  'admin.bugs.unread': '条未读',

  // Bug Feedback (user-facing settings tab)
  'settings.tabs.bugFeedback': 'Bug 反馈',
  'settings.tabs.bugFeedbackDesc': '提交和查看 Bug 报告',
  'bugFeedback.title': 'Bug 反馈',
  'bugFeedback.description': '提交 Bug 报告帮助我们改进产品',
  'bugFeedback.field.title': '标题',
  'bugFeedback.field.titlePlaceholder': '简要描述遇到的问题',
  'bugFeedback.field.description': '详细描述',
  'bugFeedback.field.descriptionPlaceholder': '详细描述你遇到的问题，包括期望行为和实际行为...',
  'bugFeedback.field.steps': '复现步骤',
  'bugFeedback.field.stepsPlaceholder': '1. 打开...\n2. 点击...\n3. 出现...',
  'bugFeedback.field.severity': '严重程度',
  'bugFeedback.field.screenshots': '截图（可选）',
  'bugFeedback.field.screenshotsHint': '拖拽或点击上传截图，最多 5 张',
  'bugFeedback.severity.low': '低 — 轻微问题',
  'bugFeedback.severity.medium': '中 — 功能受限',
  'bugFeedback.severity.high': '高 — 核心功能不可用',
  'bugFeedback.severity.critical': '严重 — 系统崩溃/数据丢失',
  'bugFeedback.submit': '提交报告',
  'bugFeedback.submitting': '提交中...',
  'bugFeedback.submitted': 'Bug 报告已提交，感谢你的反馈！',
  'bugFeedback.submitFailed': '提交失败，请重试',
  'bugFeedback.required': '标题和描述为必填项',
  'bugFeedback.myReports': '我的报告',
  'bugFeedback.noReports': '暂无报告',
  'bugFeedback.total': '条',
  'bugFeedback.empty': '暂无 Bug 报告',
  'bugFeedback.screenshots.uploadFailed': '截图上传失败',
  'bugFeedback.screenshots.hint': '拖拽或点击上传截图，最多 5 张',
  'bugFeedback.status.open': '待处理',
  'bugFeedback.status.read': '已读',
  'bugFeedback.status.in_progress': '处理中',
  'bugFeedback.status.resolved': '已解决',
  'bugFeedback.status.closed': '已关闭',

  // 设计迁移批次 0：工作台运行时状态（唯一状态芯片/不可用卡共用）
  'workbench.status.checking': '正在连接工作台服务…',
  'workbench.status.ready': '服务就绪',
  'workbench.status.unavailable': '服务暂时不可用',
  'workbench.status.unavailableDetail': '连接智能体服务失败，可能是网络波动或服务正在重启，请重试。',
  'workbench.status.networkDetail': '网络异常，无法连接智能体服务，请检查网络后重试。',
  'workbench.status.disabled': '该工作台暂未开放',
  'workbench.status.disabledDetail': '当前环境尚未启用此工作台，请联系管理员或稍后再来。',
  'workbench.status.unauthorized': '登录状态已失效',
  'workbench.status.unauthorizedDetail': '请重新登录后再使用该工作台。',
  'workbench.status.notFound': '服务尚未部署',
  'workbench.status.notFoundDetail': '该工作台服务在当前部署中不存在，可能是版本尚未更新。',
  'workbench.status.retry': '重试',
  'workbench.status.rawDetailPrefix': '原始信息',

  // 设计迁移批次 4:工作台统一壳(唯一状态芯片 + 它如何工作折叠 + 返回)
  'workbench.back': '返回',
  'workbench.newSession': '新对话',
  'workbench.syncMode': '同步模式',
  'workbench.howItWorks': '它如何工作',
  'workbench.handoffTitle': '来自主聊天的续办任务',
  'workbench.handoffIdentifiers': '任务标识符',

  // 设计迁移批次 5:工作台产物列操作
  'workbench.artifact.export': '导出',
  'workbench.artifact.cite': '引用',

  'chat.modeGroup': '模式',

  'errorReview.settled': '回答已提交,本题复习完成。',};
